export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 2.4,
        "transcript": "…qanerluni ataucimek pivkenaku.",
        "translation": "…he didn't refer to it as one."
    },
    "2": {
        "startTime": 2.5,
        "endTime": 6.0,
        "transcript": "Tuarpiaq malrugnek umyuarluni.",
        "translation": "It seemed like a hypocrite."
    },
    "3": {
        "startTime": 7.0,
        "endTime": 9.0,
        "transcript": "Ilait-llu waten qanerluteng:",
        "translation": "And some say this:"
    },
    "4": {
        "startTime": 9.5,
        "endTime": 12.5,
        "transcript": "Kass'atun tau͡gaam yuk uvkeqerkauluku.",
        "translation": "They will only believe a person speaking in English."
    },
    "5": {
        "startTime": 13.5,
        "endTime": 17.0,
        "transcript": "Yugtun qallatengraan ukveqerkauvkenaku.",
        "translation": "They will not believe him even if he speaks Yup'ik."
    },
    "6": {
        "startTime": 17.5,
        "endTime": 22.0,
        "transcript": "Tamaa-i-gguq umyugaat elluatuunrirluni.",
        "translation": "They say that their minds are no longer true."
    },
    "7": {
        "startTime": 24.5,
        "endTime": 32.0,
        "transcript": "Nutem man'a qaneryararput Agayutmek cikiutekngamteggu piniulliniuq wangkutnun.",
        "translation": "Because our language is a gift from God, it is our strength."
    },
    "8": {
        "startTime": 33.0,
        "endTime": 39.5,
        "transcript": "Tuaggun ca caperrnarqengraan piyugngaluku uuggun qantucimteggun Yugcetun.",
        "translation": "We can do anything though it seems impossible through our ability to speak Yup'ik."
    },
    "9": {
        "startTime": 42.0,
        "endTime": 44.0,
        "transcript": "Avirautelliniuq.",
        "translation": "It's in the way."
    },
    "10": {
        "startTime": 61.0,
        "endTime": 63.0,
        "transcript": "Tua-llu? Tape-aq-qaa maa-i roll-artuq?",
        "translation": "Ready? Is the tape rolling this time?"
    },
    "11": {
        "startTime": 66.0,
        "endTime": 72.0,
        "transcript": "Ii-i. Tamatumek-am tuaten qalarut'lallruit ciuliamta arcaqerluni.",
        "translation": "Okay. Our ancestors used to say that was the most important."
    },
    "12": {
        "startTime": 72.5,
        "endTime": 74.0,
        "transcript": "Waten-ll' ilait qanraqluteng:",
        "translation": "And some said this:"
    },
    "13": {
        "startTime": 75.5,
        "endTime": 85.5,
        "transcript": "“Yugcetun qaneneq nalluyaguskuvciu, qaneryarat-llu makut ayuqucirtuutet nalluyaguciiqaci.",
        "translation": "“If you forget how to speak Yup'ik, you will also forget the words of wisdom and the teachings."
    },
    "14": {
        "startTime": 85.6,
        "endTime": 89.0,
        "transcript": "“Cauciqceci-mi tuaten ayuqlirikuvci?”",
        "translation": "“Who will you be if you become like that?”"
    },
    "15": {
        "startTime": 91.5,
        "endTime": 96.0,
        "transcript": "Kitak' maavet ek'arrlunuk waniwa.",
        "translation": "Now, let's get into this now."
    },
    "16": {
        "startTime": 96.5,
        "endTime": 105.9,
        "transcript": "Ak'a ava-i wani alerquun, alerquutet Yupiit alerquutait angelriit iliit",
        "translation": "The ancient instruction, one of the most important of Yup'ik instructions"
    },
    "17": {
        "startTime": 106.0,
        "endTime": 112.0,
        "transcript": "Man'a wani kencikiyaraq nunamek, caungraan man'a wani kencikiyaraq.",
        "translation": "Is revering the land, revering everything no matter what it is."
    },
    "18": {
        "startTime": 112.1,
        "endTime": 117.0,
        "transcript": "Tamana alerquun caucia qanrutkeqerru.",
        "translation": "Please talk about what that instruction is."
    },
    "19": {
        "startTime": 118.8,
        "endTime": 126.0,
        "transcript": "Maavet-llu maa-i wavet ernemteńun tekilluten tangllerpenek elpet qanrutqerki.",
        "translation": "Please also talk about what you have seen as you have lived up to this day."
    },
    "20": {
        "startTime": 127.0,
        "endTime": 130.0,
        "transcript": "Yaa, maa-i-q' ayagnirnariuq? Ii-i.",
        "translation": "Yes, is it time to start? Okay."
    },
    "21": {
        "startTime": 130.5,
        "endTime": 132.0,
        "transcript": "Atqa-q' ciumek piluku?",
        "translation": "Do I say my name first?"
    },
    "22": {
        "startTime": 133.5,
        "endTime": 136.5,
        "transcript": "Waniwa wiinga atengqertua Joshua Phillip.",
        "translation": "My name is Joshua Phillip."
    },
    "23": {
        "startTime": 137.5,
        "endTime": 146.0,
        "transcript": "Yuurtellrulua… Yugtun ima Maqisteńgulua; nickname-aqluku Maqista.",
        "translation": "I was born… I am Maqista in Yup'ik; Maqista is my nickname."
    },
    "24": {
        "startTime": 146.5,
        "endTime": 155.0,
        "transcript": "Tau͡gken atpiaqa Ac'urunauluni. Angllullemni tuaten uitaluni.",
        "translation": "But my real name is Ac'urunaq. That was my name given at birth."
    },
    "25": {
        "startTime": 156.0,
        "endTime": 159.0,
        "transcript": "Yuurtellrulua January 1, 1912.",
        "translation": "I was born on January 1, 1912."
    },
    "26": {
        "startTime": 160.5,
        "endTime": 165.0,
        "transcript": "Maa-i allrakunglua 79-aarlua.",
        "translation": "I am now 79 years old."
    },
    "27": {
        "startTime": 166.8,
        "endTime": 172.0,
        "transcript": "Waniwa tangllemnek, tangaallemnek taringekemnek-llu wiinga",
        "translation": "What I have seen, watched, and understood"
    },
    "28": {
        "startTime": 172.5,
        "endTime": 179.0,
        "transcript": "Allam pikenrilkiinek, wii tau͡gaam taringellemnek qanrutqataramci.",
        "translation": "I am going to tell youpl about what I personally understand, not anyone else."
    },
    "29": {
        "startTime": 181.5,
        "endTime": 187.0,
        "transcript": "Au͡gkut ciuliaput qanruyutengqellrulliniut waten:",
        "translation": "Our ancestors apparently had this piece of wisdom:"
    },
    "30": {
        "startTime": 189.0,
        "endTime": 196.5,
        "transcript": "Ilan yuullguten nutaan-llu tangengerpegu elluarrluki ciuniuqiu",
        "translation": "Even if you see your fellow human for the first time, welcome him well"
    },
    "31": {
        "startTime": 197.5,
        "endTime": 200.0,
        "transcript": "Kenekluku-llu elpetun pitarrluku.",
        "translation": "And love him as much as yourself."
    },
    "32": {
        "startTime": 200.5,
        "endTime": 206.0,
        "transcript": "Amta-llu makunek Bible-aanek akurtuqsaunateng, tangeqsaunateng.",
        "translation": "And yet they had never received or seen this Bible."
    },
    "33": {
        "startTime": 206.8,
        "endTime": 210.0,
        "transcript": "Kass'amek-ll' ataucirraungraan tangeqsaunateng.",
        "translation": "And they had never seen even one Caucasian."
    },
    "34": {
        "startTime": 211.5,
        "endTime": 213.0,
        "transcript": "Aturarluteng-llu amirrlainarnek.",
        "translation": "And they wore clothes that were all fur."
    },
    "35": {
        "startTime": 213.5,
        "endTime": 216.0,
        "transcript": "Tau͡gken waniw' qanruyutiit:",
        "translation": "Yet here is their traditional wisdom:"
    },
    "36": {
        "startTime": 216.5,
        "endTime": 219.0,
        "transcript": "Ilan kenkarkaugan elpetun pitarrluku.",
        "translation": "You must love your peer as much as yourself."
    },
    "37": {
        "startTime": 220.5,
        "endTime": 224.0,
        "transcript": "Mat'umi-am nutaan taringua",
        "translation": "Now, I finally understand"
    },
    "38": {
        "startTime": 225.5,
        "endTime": 232.5,
        "transcript": "Ukvemteńi uumi Jesus-aam-gguq una atrautellruaq malruk waten qanerluni:",
        "translation": "In our belief, they say that Jese brought two [commandments] down saying this:"
    },
    "39": {
        "startTime": 232.8,
        "endTime": 236.0,
        "transcript": "Alerquutet-gguq Moses-aakun cikiutekumaut",
        "translation": "The commandments were given through Moses"
    },
    "40": {
        "startTime": 236.5,
        "endTime": 243.5,
        "transcript": "Tau͡gaam-gguq una naklekun piciun-llu Jesus Christ-aakun pillruuq.",
        "translation": "But compassion and truthfulness [came] from Jesus Christ."
    },
    "41": {
        "startTime": 244.8,
        "endTime": 252.0,
        "transcript": "Tua-i-llu nutaan imkut ciuliamta au͡gkut nallutmun qanruyutiit:",
        "translation": "And then, our ancestors' unknowing traditional wisdom:"
    },
    "42": {
        "startTime": 252.5,
        "endTime": 255.5,
        "transcript": "Ilan kenkarkaugan elpetun pitarrluku.",
        "translation": "You must love your peer as much as yourself."
    },
    "43": {
        "startTime": 256.7,
        "endTime": 261.5,
        "transcript": "Ciuliamta arcaqerluku alerquutekaat waten qanerluteng:",
        "translation": "Our ancestors instructed that most importantly, saying this:"
    },
    "44": {
        "startTime": 262.5,
        "endTime": 268.0,
        "transcript": "“Pivakarluten qallaciiqut yuk tauna qanrucunaitniluku,",
        "translation": "“Eventually, they will start saying that person cannot be fixed,"
    },
    "45": {
        "startTime": 269.0,
        "endTime": 271.9,
        "transcript": "“Assiitniluku, inerciigatniluku.”",
        "translation": "“That he is bad, mischievous.”"
    },
    "46": {
        "startTime": 272.0,
        "endTime": 274.0,
        "transcript": "Waniw' qanruyutiit:",
        "translation": "Here is their traditional wisdom:"
    },
    "47": {
        "startTime": 274.5,
        "endTime": 280.0,
        "transcript": "“Taukunun qanelrianun maligtaqucaqunak watqapik.",
        "translation": "“Do not, under any circumstances, go along with what they're saying."
    },
    "48": {
        "startTime": 280.5,
        "endTime": 283.5,
        "transcript": "“Tauna-llu cangakellrat cangaksaqunaku.",
        "translation": "“And do not criticize the one they criticize."
    },
    "49": {
        "startTime": 283.8,
        "endTime": 292.0,
        "transcript": "“Tangerquvgu-llu qanrruuguskiu angnillerkaakun, kaikan-llu nerevkarluku.",
        "translation": "“And if you see him, chat with him so he'll be happy, and feed him if he's hungry."
    },
    "50": {
        "startTime": 293.0,
        "endTime": 302.5,
        "transcript": "“Aturarrliqkan-llu aturan navervingqerqata, aturavet iliitnek cikirrarniaran tangerrluku tauna.”",
        "translation": "“And if his clothes are tattered, if you have any to spare, look at him and give him one of your clothes.”"
    },
    "51": {
        "startTime": 303.0,
        "endTime": 307.0,
        "transcript": "Tamaa-i-nguuq ilakuyun, kenkuyun",
        "translation": "That is treating others well, showing love"
    },
    "52": {
        "startTime": 307.1,
        "endTime": 312.0,
        "transcript": "Avaken ciuliamteńek ayagluni alerquun angtatailnguq.",
        "translation": "The most important instruction from our ancient ancestors."
    },
    "53": {
        "startTime": 313.5,
        "endTime": 318.0,
        "transcript": "Tuamta-llu Bible-aani waten naaqilartua:",
        "translation": "And then, I read this in the Bible:"
    },
    "54": {
        "startTime": 319.0,
        "endTime": 328.0,
        "transcript": "Alerquutet-gguq ukut Old Testament and New Testament ataucimurcimaut ataucikun qaneryarakun waten qanerluteng:",
        "translation": "It's said that the Old Testament and New Testament are unified into one word saying this:"
    },
    "55": {
        "startTime": 329.0,
        "endTime": 332.0,
        "transcript": "“Ilan kenkarkaugan elpetun pitarrluku.”",
        "translation": "“You must love your peer as much as yourself.”"
    },
    "56": {
        "startTime": 332.5,
        "endTime": 336.5,
        "transcript": "Tamaa-i-nguuq. Allamek anirtuutaitukut.",
        "translation": "That's what it is. We have no other salvation."
    },
    "57": {
        "startTime": 337.5,
        "endTime": 341.0,
        "transcript": "Allamek-gguq ellarpallraam aciani anirtuutaitukut",
        "translation": "They say that we have no other salvation under this entire world"
    },
    "58": {
        "startTime": 341.5,
        "endTime": 346.0,
        "transcript": "Uum naklekiyaram piciuyaram-llu avatiini.",
        "translation": "Except for compassion and truthfulness."
    },
    "59": {
        "startTime": 347.0,
        "endTime": 354.5,
        "transcript": "Una naklekiyaraq piciuyaraq-llu kiigkenka arcaqerlukek ciuliamta alerquutekegket.",
        "translation": "This compassion and truthfulness were the most important instructions of our ancestors."
    },
    "60": {
        "startTime": 355.5,
        "endTime": 358.0,
        "transcript": "Una piciuyaraq waten ayuquq:",
        "translation": "This is what truthfulness is like:"
    },
    "61": {
        "startTime": 360.0,
        "endTime": 365.0,
        "transcript": "Qanresqevkenata iqluurluta, qanengssaasqevkenata-llu iqluurluta,",
        "translation": "That we should not speak lies, nor give false accounts,"
    },
    "62": {
        "startTime": 366.0,
        "endTime": 369.5,
        "transcript": "Piciulriarrlainarnek tau͡gaam qantusqelluta.",
        "translation": "But only speak the truth."
    },
    "63": {
        "startTime": 371.0,
        "endTime": 375.5,
        "transcript": "Uum wani naklekiyaram aipaqluku, ilakluku.",
        "translation": "It is the companion of compassion, related to it."
    },
    "64": {
        "startTime": 376.0,
        "endTime": 382.5,
        "transcript": "Malruulukek Jesus-aam atraucamikek naklekun piciun-llu",
        "translation": "There were two that Jesus brought down, compassion and truthfulness"
    },
    "65": {
        "startTime": 383.5,
        "endTime": 391.5,
        "transcript": "Ciuliamta niipailegmegteggu ak'a kinguliarameggnun sagtellrulliniluku tauna neklekiyaraq.",
        "translation": "Long before our ancestors heard it, they scattered that compassion among their descendants."
    },
    "66": {
        "startTime": 392.5,
        "endTime": 395.0,
        "transcript": "Kenka angtataituq.",
        "translation": "Love is the greatest."
    },
    "67": {
        "startTime": 395.5,
        "endTime": 398.0,
        "transcript": "Allamek-llu-gguq Bible-aat qanertut:",
        "translation": "They also say that the Bible says something else:"
    },
    "68": {
        "startTime": 398.7,
        "endTime": 405.5,
        "transcript": "Allamek-gguq anirtuutaitukut uum naklekiyaram piciuyaram-ll' avatiigni.",
        "translation": "We have no other salvation except through compassion and truthfulness."
    },
    "69": {
        "startTime": 406.0,
        "endTime": 410.5,
        "transcript": "Tua-i taukuk angtatailnguuk qanruyutek wangkutnun.",
        "translation": "Those2 are the greatest pieces2 of traditional wisdom for us."
    },
    "70": {
        "startTime": 411.5,
        "endTime": 413.5,
        "transcript": "Man'a-q' pitalkeksaituq?",
        "translation": "Has this been according [to what was planned]?"
    },
    "71": {
        "startTime": 414.0,
        "endTime": 415.0,
        "transcript": "Pitalkuq.",
        "translation": "It is."
    },
    "72": {
        "startTime": 415.7,
        "endTime": 422.5,
        "transcript": "Nutaan qanengssakatartua mat'umi up'nerkami pektellemnek.",
        "translation": "I am now going to talk about how we traveled this spring."
    },
    "73": {
        "startTime": 423.5,
        "endTime": 427.5,
        "transcript": "Waten-am umyuangua up'nerkaq kiagniararluku:",
        "translation": "In the spring nearing summer, I had this idea:"
    },
    "74": {
        "startTime": 428.5,
        "endTime": 433.0,
        "transcript": "Angu ataki tang pavavet pissualallma iliininun",
        "translation": "Well now, to one of my past hunting grounds inland"
    },
    "75": {
        "startTime": 434.0,
        "endTime": 444.5,
        "transcript": "Kiakan aguutekun levaacuaralegkun tamana tarritelallma iliit tangerrsartuqaqerlaku.",
        "translation": "When summer sets, I should go see one of the places I used to walk about with a canoe that has a small motor."
    },
    "76": {
        "startTime": 445.5,
        "endTime": 448.0,
        "transcript": "Tua-i-llu kiagan cikuirucan",
        "translation": "And then when summer set and there was no more ice"
    },
    "77": {
        "startTime": 449.5,
        "endTime": 456.0,
        "transcript": "Tuulkessaarmiut kiatiitgun tevyarakun tevluta Elaayuum kangranun.",
        "translation": "We portaged through the route upriver from Tuluksak to the headwaters of Elaayuk."
    },
    "78": {
        "startTime": 456.5,
        "endTime": 460.0,
        "transcript": "Nutaan tuaggun cetuukut.",
        "translation": "That's the first time we went downriver through there."
    },
    "79": {
        "startTime": 461.5,
        "endTime": 467.0,
        "transcript": "Cetuinanemteńi pengulkugmun tekitaqamta arulairlua nacetaqlua.",
        "translation": "When we came upon tussocks of grass as we went downriver, I would stop and look around from a vantage point."
    },
    "80": {
        "startTime": 468.5,
        "endTime": 474.0,
        "transcript": "Nacetaqama tekitnaurtua uumek pop-autellermek.",
        "translation": "When I was climbing to vantage points, I would come across empty pop containers."
    },
    "81": {
        "startTime": 475.0,
        "endTime": 478.5,
        "transcript": "Maani-llu kuigmi levaarinanemni",
        "translation": "And as I traveled with my motor on the river"
    },
    "82": {
        "startTime": 479.5,
        "endTime": 486.0,
        "transcript": "Tangerrnaurtua napat avayaitni plastic-aaq kevingaluni.",
        "translation": "I would see plastic stuffed in tree branches."
    },
    "83": {
        "startTime": 486.5,
        "endTime": 489.0,
        "transcript": "Tuavet nagingalliniluni.",
        "translation": "It would be stuck there."
    },
    "84": {
        "startTime": 489.5,
        "endTime": 491.5,
        "transcript": "Tamakunek tangaagua.",
        "translation": "I saw a lot of those."
    },
    "85": {
        "startTime": 492.0,
        "endTime": 495.5,
        "transcript": "Qaillun-llu umyuarteqeksaunii ciuqlirmi kangingellemni.",
        "translation": "I didn't think anything when I first found out."
    },
    "86": {
        "startTime": 496.5,
        "endTime": 500.0,
        "transcript": "Kiituani tang avani uaqsigiluta",
        "translation": "Eventually, we went far downriver over there"
    },
    "87": {
        "startTime": 501.0,
        "endTime": 504.0,
        "transcript": "Nakleng, cat tamalkuita pop-autengqerran",
        "translation": "Pity, because everything had old pop containers"
    },
    "88": {
        "startTime": 505.0,
        "endTime": 509.5,
        "transcript": "Pop-autellernek pitangqerran umyuangua",
        "translation": "I had a though because there were old pop containers"
    },
    "89": {
        "startTime": 509.6,
        "endTime": 513.5,
        "transcript": "All' atam wangkuta makut irniaput.",
        "translation": "My goodness, look at our children."
    },
    "90": {
        "startTime": 514.5,
        "endTime": 520.0,
        "transcript": "Cakneq-lli uqlaussiyaagpaa ciuliamcetun pivkenani.",
        "translation": "It's way too polluted, not like our ancestors."
    },
    "91": {
        "startTime": 523.5,
        "endTime": 525.5,
        "transcript": "Ukuugut arcaqerluteng:",
        "translation": "These are the most prevalent:"
    },
    "92": {
        "startTime": 526.5,
        "endTime": 534.5,
        "transcript": "Pop-autellret, plastic-aat, atsiyaryaraitni-wa terr'ilitat cali.",
        "translation": "Old pop containers, plastic, and where the pick berries, diapers too."
    },
    "93": {
        "startTime": 535.0,
        "endTime": 541.5,
        "transcript": "Qavartallrit-llu carangllirrlainarluteng qemagngavkenateng tamakut.",
        "translation": "And in their camp sites, there's nothing but debris where those aren't put away."
    },
    "94": {
        "startTime": 542.7,
        "endTime": 549.0,
        "transcript": "Avani tang ciuliamteńi nuna man'a menuunaku.",
        "translation": "Back in our ancestors' time, they made the land pristine."
    },
    "95": {
        "startTime": 551.0,
        "endTime": 554.0,
        "transcript": "Carangllugtaunani, tamakunek pitautani.",
        "translation": "There was no pollution, none of those."
    },
    "96": {
        "startTime": 554.8,
        "endTime": 562.0,
        "transcript": "Pop-autellernek, cavilqunek, plastic-aanek, terr'ilillernek pitaunani.",
        "translation": "There were no old pop containers, metal, plastic, or diapers."
    },
    "97": {
        "startTime": 563.5,
        "endTime": 568.5,
        "transcript": "Tamakut-llu pinginanratni kuvyallernek cali.",
        "translation": "And as they were there, old drift nets too."
    },
    "98": {
        "startTime": 570.0,
        "endTime": 578.5,
        "transcript": "Maani tayima kangitmun Kusquqvak Akula-llu pau͡gna tuaten uksurpak civingallernek.",
        "translation": "What [nets] that were set all winter is here to the mouth of the Kuskokwim and even the Akula region inland."
    },
    "99": {
        "startTime": 579.0,
        "endTime": 585.0,
        "transcript": "Uqlarluni. Uqlauciluni neqnek, nuna-llu man'a uqlarluni.",
        "translation": "It's polluted. It's polluting the fish, and the land here is polluted."
    },
    "100": {
        "startTime": 588.0,
        "endTime": 593.9,
        "transcript": "Akwaugaq-llu au͡gna Matthew Beans-aaq qanemcillermini qanemciuq waten:",
        "translation": "And yesterday, when Matthew Beans was telling a story, he said this:"
    },
    "101": {
        "startTime": 594.0,
        "endTime": 597.9,
        "transcript": "Tengaurcuutetgun-gguq nunanun ayagaaqami",
        "translation": "When he goes to villages on planes"
    },
    "102": {
        "startTime": 598.0,
        "endTime": 608.0,
        "transcript": "Nunat mallgiaqamiki tamakunek plastic-aanek kalikallernek-llu tangaangelartuq nunat mallgiaqamiki",
        "translation": "He sees a lot of those plastic and paper products when he gets close to villages"
    },
    "103": {
        "startTime": 608.5,
        "endTime": 611.5,
        "transcript": "Anuqem pirtukluki ayagatellri.",
        "translation": "The things that the wind carried like a storm."
    },
    "104": {
        "startTime": 614.0,
        "endTime": 620.5,
        "transcript": "Waten tang umyuangellrulrianga wiinga up'nerkaq tamaaggun tamakunek tangerpakallemni:",
        "translation": "When I saw those so much there, I had this thought last spring:"
    },
    "105": {
        "startTime": 621.5,
        "endTime": 623.9,
        "transcript": "Qanrutkarkaurrluki agayuvigmi.",
        "translation": "I will tell them in the church."
    },
    "106": {
        "startTime": 624.0,
        "endTime": 629.0,
        "transcript": "Wall'u agayuviunrilengraan tamakut apertuagarkaurrluki.",
        "translation": "Or even outside of the church, I will point those out to them."
    },
    "107": {
        "startTime": 630.0,
        "endTime": 632.9,
        "transcript": "Ciuliaput menuitellruut.",
        "translation": "Our ancestors were pristine."
    },
    "108": {
        "startTime": 633.8,
        "endTime": 638.5,
        "transcript": "Nunaseng man'a kencikluku clean up-aarumarrlainarluku.",
        "translation": "They revered their land here and alwauys kept it cleaned up."
    },
    "109": {
        "startTime": 639.5,
        "endTime": 645.0,
        "transcript": "Piinanermeggni-llu merteng Kusquqvak",
        "translation": "And in their time, their water, the Kuskokwim"
    },
    "110": {
        "startTime": 645.5,
        "endTime": 652.0,
        "transcript": "Kusquqvaunrilengraan nanvat kuiggaat-llu kencikluki, uqlarcetevkenaki.",
        "translation": "Even outside of the Kuskokwim, they revered the creeks too, kept them from being polluted."
    },
    "111": {
        "startTime": 652.5,
        "endTime": 655.5,
        "transcript": "Nuna-llu piyararteng uqlarcetevkenaku.",
        "translation": "Neither did they pollute the land where they subsisted."
    },
    "112": {
        "startTime": 656.0,
        "endTime": 662.0,
        "transcript": "Clean up-aarumarrlainarluku ciuliamta waten qanerluteng:",
        "translation": "Our ancestors always kept it cleaned up saying this:"
    },
    "113": {
        "startTime": 662.5,
        "endTime": 665.5,
        "transcript": "Ellam Yuan tangvagaakut.",
        "translation": "The Spirit of the Universe is watching us."
    },
    "114": {
        "startTime": 666.8,
        "endTime": 670.0,
        "transcript": "Cipciyuunata-gguq Ellam Yuan tangvagaakut.",
        "translation": "They said that the Spirit of the Universe is watching us without leaving anyone out."
    },
    "115": {
        "startTime": 671.5,
        "endTime": 677.0,
        "transcript": "Bible-aani naaqilartut tayima elisngalriit, wiinga-llu naaqelartua",
        "translation": "The intelligent read in the Bible, and I read too"
    },
    "116": {
        "startTime": 678.0,
        "endTime": 681.0,
        "transcript": "Psalms 24-aami waten qanertuq:",
        "translation": "It says this in Psalms 24:"
    },
    "117": {
        "startTime": 681.3,
        "endTime": 686.0,
        "transcript": "Agayutem nuna pikaa tamakunelnguut-llu tamalkuita.",
        "translation": "God owns the land and everything on it."
    },
    "118": {
        "startTime": 686.5,
        "endTime": 690.5,
        "transcript": "Tuani-llu enengqellriit tamalkuita elliin pikai.",
        "translation": "He also owns all that live there."
    },
    "119": {
        "startTime": 692.5,
        "endTime": 702.5,
        "transcript": "Nakleng wangkuta mat'um nalliini nunamteńek uqlarilriani ukvelrianek aterpagingaluta.",
        "translation": "Pity, we who are polluting our land these days who are called [Christian] believers."
    },
    "120": {
        "startTime": 703.5,
        "endTime": 710.0,
        "transcript": "Ukvelriaruciqukut-qaa air-arput nunaput-llu uqlarluku?",
        "translation": "Will we [truly] be believers polluting our air and land?"
    },
    "121": {
        "startTime": 711.0,
        "endTime": 714.5,
        "transcript": "Maaten umyuangcartua",
        "translation": "I pondered and realized"
    },
    "122": {
        "startTime": 715.0,
        "endTime": 719.5,
        "transcript": "Ukvelriani wangkuta tuaten air-angqerrngaitellinilriakut.",
        "translation": "That we believers will evidently not have air like that."
    },
    "123": {
        "startTime": 720.5,
        "endTime": 726.5,
        "transcript": "Nunavut uitavigput uksumi, pissurviput-llu yuilqumi",
        "translation": "Our village where we stay in the winter, and our subsisting grounds in the wilderness"
    },
    "124": {
        "startTime": 728.0,
        "endTime": 734.0,
        "transcript": "Enecetun clean up-aarumalriatun ayuqevkararkauyaaqelliniarput",
        "translation": "We must keep them like a cleaned up house"
    },
    "125": {
        "startTime": 734.1,
        "endTime": 740.5,
        "transcript": "Wangkuta air-arput, pissuryaraput, neqsurviit, Kusquqvagput-llu.",
        "translation": "Our air, hunting grounds, fishing grounds, and our Kuskokwim."
    },
    "126": {
        "startTime": 741.7,
        "endTime": 748.0,
        "transcript": "Mat'um-llu nalliini ayainanemni Kusquqvagkun tangerrnaurtua pop-autelleq man'a atreskii.",
        "translation": "And these days as I travel on the Kuskokwim, I would see a pop container drifting along here."
    },
    "127": {
        "startTime": 748.9,
        "endTime": 754.9,
        "transcript": "Amta-llu nerangnaqvikluku akingengnaqvikluku-llu.",
        "translation": "And yet it's where we subsist and commercial fish."
    },
    "128": {
        "startTime": 755.0,
        "endTime": 758.5,
        "transcript": "Ik'atak qalquni qaillun piciqa?",
        "translation": "Gross, what will happen when it rusts?"
    },
    "129": {
        "startTime": 760.0,
        "endTime": 762.5,
        "transcript": "Au͡gkut tang ciuliaput waten qanelriit:",
        "translation": "You see, our ancestors back then said this:"
    },
    "130": {
        "startTime": 763.5,
        "endTime": 767.0,
        "transcript": "Makut-gguq neqet cumucitartut.",
        "translation": "These fish are easily repulsed."
    },
    "131": {
        "startTime": 768.0,
        "endTime": 772.5,
        "transcript": "Man'a-gguq kuik assiitellriamek camek aungqerqan",
        "translation": "They said that if these river has anything bad in it"
    },
    "132": {
        "startTime": 773.5,
        "endTime": 777.5,
        "transcript": "Neqet aturngaitaat unguvatekngamegteggu meq.",
        "translation": "The fish will not go in it because water keeps them alive."
    },
    "133": {
        "startTime": 778.0,
        "endTime": 783.5,
        "transcript": "Nallunrilameng atuqunegteggu tuquciqngameng kangillipailegmegteggu.",
        "translation": "Because they know that if they go in it, they will die before they reach its headwaters."
    },
    "134": {
        "startTime": 784.0,
        "endTime": 789.0,
        "transcript": "Aturciigatait-gguq uqlalria meq neqet avaken ayagluteng.",
        "translation": "Since a long time ago, they say that they can't go in polluted water."
    },
    "135": {
        "startTime": 789.5,
        "endTime": 798.0,
        "transcript": "Makut nunam auluklerkaa, mer'em-llu auluklerkaa avaken ayagluki ciuliamteńek",
        "translation": "Since our ancestors' time back then, taking care of the land and taking care of the water"
    },
    "136": {
        "startTime": 798.1,
        "endTime": 806.5,
        "transcript": "Millions of millions year pellugluteng taringumarillerteng inerquutekait piciulria.",
        "translation": "They have admonishments on those from what true things they have learned over millions of millions [of] years."
    },
    "137": {
        "startTime": 806.9,
        "endTime": 809.5,
        "transcript": "Piciulriit tau͡gaam inerquutek'larait",
        "translation": "Their admonishments only concern what is true"
    },
    "138": {
        "startTime": 809.9,
        "endTime": 813.5,
        "transcript": "Taringelteng nakmiin iimegteggun tangaalteng.",
        "translation": "What they understand, what they have seen with their very own eyes."
    },
    "139": {
        "startTime": 814.0,
        "endTime": 821.4,
        "transcript": "Taumek tuaten ayuqngan man'a mat'um nalliini murilkeqernaurtukut.",
        "translation": "Because it's like that now, we must take care these days."
    },
    "140": {
        "startTime": 821.5,
        "endTime": 827.5,
        "transcript": "Cairusngiinartuq neqairusngiinarluni-llu mat'um nalliini",
        "translation": "Things are depleting, and fish are depleting this days"
    },
    "141": {
        "startTime": 828.5,
        "endTime": 834.0,
        "transcript": "Merput nunaput-llu kencikenrilamteki iqaurcamteggu wangkuta.",
        "translation": "Because we are not respecting our water and land, polluting them."
    },
    "142": {
        "startTime": 835.8,
        "endTime": 838.0,
        "transcript": "Makut-qaa ekuasciigataput?",
        "translation": "Can't we incinerate these [our garbage]?"
    },
    "143": {
        "startTime": 839.1,
        "endTime": 848.5,
        "transcript": "Wall'u nunapigmun patulluki unicunaqsaaqaput nunavut clean up-aarumavkarluku.",
        "translation": "Or, we must leave them buried in the land to keep our land cleaned up."
    },
    "144": {
        "startTime": 850.0,
        "endTime": 858.0,
        "transcript": "Nallunrituci enengqellriani assilrianek caranglliisqumanritarci enesi.",
        "translation": "Nallunrituci enengqellriani assilrianek caranglliisqumanritarci enesi."
    },
    "145": {
        "startTime": 859.5,
        "endTime": 866.5,
        "transcript": "Arcaqanrulria waniwa nunasi air-arci-llu pissurvigci.",
        "translation": "Your land, air, and hunting grounds are more important."
    },
    "146": {
        "startTime": 867.0,
        "endTime": 874.5,
        "transcript": "Tuaten nutaan arcaqanruluku murilkarkauyaaqerci nakmiin qavarvigpeceńi enemi.",
        "translation": "You must watch over it more than your own homes where you sleep."
    },
    "147": {
        "startTime": 875.0,
        "endTime": 877.5,
        "transcript": "Clean up-aarumavkarluku.",
        "translation": "Keep it cleaned up."
    },
    "148": {
        "startTime": 878.0,
        "endTime": 885.5,
        "transcript": "Waten mat'um nalliini nunavut uqlangan Agayutem atawaqerceciigataa.",
        "translation": "Because our land is polluted these days, God cannot bless it."
    },
    "149": {
        "startTime": 886.0,
        "endTime": 891.0,
        "transcript": "Cat ikegliinavkarluki, neqet ikegliinavkarluki",
        "translation": "He's reducing things, reducing the fish"
    },
    "150": {
        "startTime": 893.0,
        "endTime": 897.0,
        "transcript": "Makut-llu cali naunraat tuar ikegliinavkarluki.",
        "translation": "And it seems he's reducing these cloudberries."
    },
    "151": {
        "startTime": 897.5,
        "endTime": 901.5,
        "transcript": "Atawaqertesciiganaku nuna uqlalria.",
        "translation": "He cannot bless a polluted land."
    },
    "152": {
        "startTime": 902.5,
        "endTime": 907.5,
        "transcript": "Allamun yugmun wall'u Kass'amun ellinrillaut",
        "translation": "Let us not put it to another person or Caucasian"
    },
    "153": {
        "startTime": 907.6,
        "endTime": 910.5,
        "transcript": "Wangkutnun tau͡gaam nunakestainun.",
        "translation": "Except to us who live in the land."
    },
    "154": {
        "startTime": 911.0,
        "endTime": 915.5,
        "transcript": "Tamakunek carririarkanek murilkiarkanek-llu",
        "translation": "Those things that must be cleaned and watched over"
    },
    "155": {
        "startTime": 915.6,
        "endTime": 922.0,
        "transcript": "Wangkutnun tau͡gaam ellilaut man'a allamun yugmun pivkenaku, nugtartevkenaku.",
        "translation": "We should only put them on ourselves, not pass them to another person."
    },
    "156": {
        "startTime": 923.0,
        "endTime": 926.0,
        "transcript": "Wangkuta murilkenrilucimcetun",
        "translation": "As we are not careful of ourselves"
    },
    "157": {
        "startTime": 926.5,
        "endTime": 932.0,
        "transcript": "Ayagyuaput-llu ayuqucirtunrilucimteńek tamatum kencikluku atu'urkaatnek",
        "translation": "And as we do not instruct our young people to respectfully use that [land]"
    },
    "158": {
        "startTime": 932.5,
        "endTime": 938.0,
        "transcript": "Tuaten ellircetarput wangkuta iirusngiimteki ayagyuaput.",
        "translation": "We're making it become like that because we hide [the knowledge] from our young people."
    },
    "159": {
        "startTime": 938.5,
        "endTime": 943.0,
        "transcript": "Kitak' waken ayagluta ayuqucirturnauput",
        "translation": "Now, let us instruct them from here on out"
    },
    "160": {
        "startTime": 943.5,
        "endTime": 949.9,
        "transcript": "Nuna share-arluku menuunaku pisqelluku.",
        "translation": "To share the land and keep it pristine."
    },
    "161": {
        "startTime": 950.5,
        "endTime": 954.4,
        "transcript": "Nallunaitqapigmek nunavut menuiruskan",
        "translation": "It's very clear that when our land becomes pristine"
    },
    "162": {
        "startTime": 954.5,
        "endTime": 958.0,
        "transcript": "Agayutem atawaqerceciiqaa ciuliamcetun",
        "translation": "God will bless it like [the time of] our ancestors"
    },
    "163": {
        "startTime": 958.5,
        "endTime": 969.0,
        "transcript": "Cat amllerivkarluki, ca tamalkuan enuryugpek'naku paivngavkarluku wangkuta atutukput maani nunami.",
        "translation": "Making things abundant, making nothing scarce, making everything we use on this land available."
    },
    "164": {
        "startTime": 969.5,
        "endTime": 976.0,
        "transcript": "Yaqulget, ungungssiaraat, tuntut, imarmiutaat-llu tuaten piyugngait.",
        "translation": "They can do that for birds, small animals, caribou, and minks."
    },
    "165": {
        "startTime": 976.5,
        "endTime": 980.0,
        "transcript": "Avani ciuliamteńi qanengssaitni qanlartut",
        "translation": "When they tell stories of our ancestors' time back then"
    },
    "166": {
        "startTime": 981.0,
        "endTime": 990.5,
        "transcript": "Taluyaarait-llu-gguq muirluteng igesciigaliaqameng cangenrilalliniut imarmiutarnek.",
        "translation": "They said that their traps would be full, and couldn't catch any more minks when they couldn't swallow."
    },
    "167": {
        "startTime": 990.9,
        "endTime": 993.5,
        "transcript": "Amllerluteng cat tamarmeng avani.",
        "translation": "Things were abundant back then."
    },
    "168": {
        "startTime": 993.7,
        "endTime": 1001.5,
        "transcript": "Nuna-wa clean up-aaran waten menuunani Agayutem atawaqercecimaluku tuaten.",
        "translation": "Because the land was cleaned up and pristine like this God blessed it like that."
    },
    "169": {
        "startTime": 1002.0,
        "endTime": 1007.0,
        "transcript": "Ca tamalkuan kemget alerquutnguluteng",
        "translation": "There were instructions for every kind of meat"
    },
    "170": {
        "startTime": 1007.5,
        "endTime": 1012.5,
        "transcript": "Aturngailkeput cipneput teq'erluki unitesqelluki.",
        "translation": "To bury the leftovers we won't use in pits and leave them."
    },
    "171": {
        "startTime": 1013.5,
        "endTime": 1020.0,
        "transcript": "Yuilqumi-llu tuntum enranek wall'u allam ungungssiaraam enranek tangerqumta",
        "translation": "And if we see a caribou bone or the bone of another small animal in the wilderness"
    },
    "172": {
        "startTime": 1020.5,
        "endTime": 1027.0,
        "transcript": "Canimelkii nanvartailkan nunamun pakiulluku tauna unitesqelluku.",
        "translation": "If there is no lake near it, to bury it in land and leave it."
    },
    "173": {
        "startTime": 1027.5,
        "endTime": 1032.5,
        "transcript": "Canimelkii nanvartangqerran tuavet nanvamun enra egcartuusqelluku.",
        "translation": "If there is a lake nearbly, go throw its bone in there."
    },
    "174": {
        "startTime": 1032.7,
        "endTime": 1035.5,
        "transcript": "Alerquutekluku ciuliamta tuaten.",
        "translation": "That's what our ancestors instructed."
    },
    "175": {
        "startTime": 1036.0,
        "endTime": 1041.5,
        "transcript": "Nuna menuunaku man'a tangllerteng pisqelluku.",
        "translation": "They asked to the keep the land that they saw here pristine."
    },
    "176": {
        "startTime": 1042.0,
        "endTime": 1048.5,
        "transcript": "Tamatumek tamaa-i qanerkanglua wii utertua up'nerkaq pektellemni tamatumek.",
        "translation": "When I returned from my travels last spring, that's what I wanted to say."
    },
    "177": {
        "startTime": 1049.5,
        "endTime": 1060.5,
        "transcript": "Waten ayuqluku uqlartaluku aulukestemta nunam-llu piliaqestiin pikestiin atawaqercesciigataa.",
        "translation": "Our caretaker, the creator and owner of the land cannot bless it when it's polluted like this."
    },
    "178": {
        "startTime": 1062.0,
        "endTime": 1063.5,
        "transcript": "Tamaa-i tamana.",
        "translation": "There you have it."
    },
    "179": {
        "startTime": 1064.0,
        "endTime": 1075.0,
        "transcript": "Tuamta-llu cali mat'um tang nunam clean up-aallra akituqapiarallinilria.",
        "translation": "And then, you see, it's apprently very expensive to clean this land up."
    },
    "180": {
        "startTime": 1077.0,
        "endTime": 1087.0,
        "transcript": "Avani tang mat'um nalliini nunani-am clean up-aarilrianek akingurluteng tangaalalrianga.",
        "translation": "These days, you see, I saw people getting paid to clean up the land over there."
    },
    "181": {
        "startTime": 1087.9,
        "endTime": 1090.0,
        "transcript": "Amta-ll' clean up-aaristeńek aterluteng.",
        "translation": "And yet, they're called cleaners."
    },
    "182": {
        "startTime": 1090.1,
        "endTime": 1093.0,
        "transcript": "Aki tau͡gaam tangvagluku watua maa-i.",
        "translation": "Now, they only have their eyes on money."
    },
    "183": {
        "startTime": 1093.8,
        "endTime": 1098.5,
        "transcript": "Avani tau͡gken ciuliamteńi aki tangvanritaat.",
        "translation": "Back then, however, our ancestors didn't watch for [money]."
    },
    "184": {
        "startTime": 1100.0,
        "endTime": 1107.0,
        "transcript": "Una tau͡gaam akaarnun yuukallerkateng kiingan tangvagaat au͡gkut ciuliamta.",
        "translation": "Our ancestors back then only looked out for living long lives."
    },
    "185": {
        "startTime": 1110.0,
        "endTime": 1112.0,
        "transcript": "Waten ayuqut:",
        "translation": "They were like this:"
    },
    "186": {
        "startTime": 1114.5,
        "endTime": 1127.0,
        "transcript": "Nunani, nunameggni canegmek naumalriartangqessuunaku clean up-aatuluku can'get nauvkarraarluku nunaseng.",
        "translation": "In their lands, there was no grass growing, [because] they cleaned up their land after the grass grew."
    },
    "187": {
        "startTime": 1128.0,
        "endTime": 1132.5,
        "transcript": "Tuamta-llu uksumi tumyarat qanikciurturatuluki.",
        "translation": "And then in the winter, they would shovel the trails."
    },
    "188": {
        "startTime": 1133.0,
        "endTime": 1137.0,
        "transcript": "Mertaryarait-llu qanikciurturatuluki ciuliamta.",
        "translation": "Our ancestors also shoveled trails to get water."
    },
    "189": {
        "startTime": 1137.8,
        "endTime": 1142.0,
        "transcript": "Tuaten ayuqngata nuniit atawaqercecimallruuq.",
        "translation": "Because they were like that, their land was blessed."
    },
    "190": {
        "startTime": 1143.0,
        "endTime": 1154.0,
        "transcript": "Tamakut-llu imkut clean up-aartet waten tamakut qanertut:",
        "translation": "And those who cleaned up would say this:"
    },
    "191": {
        "startTime": 1154.5,
        "endTime": 1161.0,
        "transcript": "“Caranglliuryunqeggluten, clean up-aaryunqeggluten yuukina aki umyuaqevkenaku.",
        "translation": "“Enjoy [cleaning] dust, enjoy cleaning up in your life without thinking of money."
    },
    "192": {
        "startTime": 1161.5,
        "endTime": 1164.9,
        "transcript": "“Akituuq clean up-aarineq.",
        "translation": "“Cleaning up is expensive."
    },
    "193": {
        "startTime": 1165.0,
        "endTime": 1173.0,
        "transcript": "“Waten ciunren ukatmun takuyallren tamarmi neqtangqerrnaurtuq.",
        "translation": "“So you may have food in your future, on everything you look back on."
    },
    "194": {
        "startTime": 1173.8,
        "endTime": 1182.5,
        "transcript": "“Tuamta-llu neqtangqerrnginanrani tuaten ciunren akaarnun unguvaqerciquten nunami.”",
        "translation": "“And then as your future always has food like that, you will live long on the earth.”"
    },
    "195": {
        "startTime": 1182.7,
        "endTime": 1185.5,
        "transcript": "Akqutii tamaa-i clean up-aaryaram.",
        "translation": "That is the promise of cleaning up."
    },
    "196": {
        "startTime": 1186.0,
        "endTime": 1189.0,
        "transcript": "Anirtima ellangellemni avani",
        "translation": "It's no wonder in my earliest memories back then"
    },
    "197": {
        "startTime": 1190.0,
        "endTime": 1197.5,
        "transcript": "Arnassagarnek angukara'urlurnek-llu tangaatuunga ciisquteng ayaperluki piyuanaurtut.",
        "translation": "I would see old women and old men supporting themselves with their knees as they walked."
    },
    "198": {
        "startTime": 1198.0,
        "endTime": 1205.0,
        "transcript": "Nengesciiganateng angukara'urluurtem arnassagaurtellrata-llu ugaani tuaten pivkarluki.",
        "translation": "They couldn't stretch [their legs] because they were such old men and old women."
    },
    "199": {
        "startTime": 1207.0,
        "endTime": 1218.0,
        "transcript": "Cunawa maa-i au͡gkut ciuliat arnaunge'rmeng nunaseng clean up-aarturatuamegteggu akaarnun yuuqatullinilriit.",
        "translation": "It turned out that our ancestors, including the women, would live long because they always cleaned up their land."
    },
    "200": {
        "startTime": 1219.5,
        "endTime": 1223.5,
        "transcript": "Ciisquteng-llu ayaperrluki tarricaurrluteng.",
        "translation": "And they started walking supporting themselves with their knees."
    },
    "201": {
        "startTime": 1224.0,
        "endTime": 1229.0,
        "transcript": "Tamaa-i clean up-aalriim akiliutii.",
        "translation": "That is the reward for those who clean up."
    },
    "202": {
        "startTime": 1229.5,
        "endTime": 1232.9,
        "transcript": "Tuamta-llu qanengssagnek waten qanernaurtut:",
        "translation": "And then they would tell these stories:"
    },
    "203": {
        "startTime": 1233.5,
        "endTime": 1239.5,
        "transcript": "Una-gguq nukalpiaq ilamitun ayuqevkanani nuqlilluni.",
        "translation": "This great hunter was lacking unlike his peers."
    },
    "204": {
        "startTime": 1240.5,
        "endTime": 1247.0,
        "transcript": "Aterluni-llu Picuilngurmek. Pitengnaq'nge'rmi-ll pitesciiganani.",
        "translation": "And his name was Picuilnguq [Bad Hunter]. And even when he tried, he wouldn't catch anything."
    },
    "205": {
        "startTime": 1247.5,
        "endTime": 1253.0,
        "transcript": "Tamakut-gguq-am ilait ayariluteng makunek piculrianek",
        "translation": "They say that those people who envy these good hunters"
    },
    "206": {
        "startTime": 1254.0,
        "endTime": 1260.0,
        "transcript": "Nunani clean up-aarteńgurtelartut kia ellimenrilengraateng.",
        "translation": "They become cleaners in villages though no one orders them to."
    },
    "207": {
        "startTime": 1261.0,
        "endTime": 1268.5,
        "transcript": "Kasngukluku picuitellerteng tamakunek nunani clean up-aarteńgurtelallinilriit.",
        "translation": "They apparently become cleaners in villages because they're ashamed that they can't catch anything."
    },
    "208": {
        "startTime": 1270.0,
        "endTime": 1275.0,
        "transcript": "Tuaten piameng tamana atu'urqamegteggu",
        "translation": "When that happens and they [clean up] like that"
    },
    "209": {
        "startTime": 1276.0,
        "endTime": 1280.0,
        "transcript": "Imkut nukalpianek piculinek-llu atellget",
        "translation": "The ones who are called great hunters, good hunters"
    },
    "210": {
        "startTime": 1280.5,
        "endTime": 1288.0,
        "transcript": "Amatairluki picunrurtaqluni tauna tuaten ayuqellria clean up-aarteńgurtaqami.",
        "translation": "A person who cleans up like that becomes a better hunter than them."
    },
    "211": {
        "startTime": 1288.5,
        "endTime": 1297.0,
        "transcript": "Waniwaulliniuq: Agayutem nunani elliin pini carriucia taumun yugmun",
        "translation": "This is what it is: God [sees] that person cleaning up his land"
    },
    "212": {
        "startTime": 1297.5,
        "endTime": 1301.5,
        "transcript": "Quyam ugaani piyullrinek akililallinia.",
        "translation": "And repays him with what he wants out of gratitude."
    },
    "213": {
        "startTime": 1302.0,
        "endTime": 1310.5,
        "transcript": "Akilitekluki. Unguvaan taktaciatun tuaten ayuqevkararkauluku enuqlitevkenaku yuuluku.",
        "translation": "That's their reward. As long as he lives, he will be like that, living without lacking anything."
    },
    "214": {
        "startTime": 1311.0,
        "endTime": 1315.5,
        "transcript": "Clean up-aarturallra man'a akituqapigtelliniuq nunam.",
        "translation": "Cleaning up the land has these great rewards."
    },
    "215": {
        "startTime": 1316.0,
        "endTime": 1318.5,
        "transcript": "Nallunguayunaitelliniarput.",
        "translation": "We should not ignore it."
    },
    "216": {
        "startTime": 1319.0,
        "endTime": 1321.0,
        "transcript": "Waten-llu qanrut'lallruitkut:",
        "translation": "They also used to tell us this:"
    },
    "217": {
        "startTime": 1321.5,
        "endTime": 1331.0,
        "transcript": "Pekcarani ikamraryarani tekiciiquten muragmek canirngalriamek ikamraryarat canirutqapiggluki.",
        "translation": "You will come across a log on its side on traveling paths completely blocking traveling paths."
    },
    "218": {
        "startTime": 1331.9,
        "endTime": 1337.5,
        "transcript": "Tamana kituryaqunaku murak caningqalria ikamraryarani.",
        "translation": "Do not pass that log laying on the traveling path."
    },
    "219": {
        "startTime": 1337.6,
        "endTime": 1341.5,
        "transcript": "Teguluku avavet ikamralqenrilkiitnun egeskiu.",
        "translation": "Take it and throw it over where travelers do not go."
    },
    "220": {
        "startTime": 1342.5,
        "endTime": 1349.5,
        "transcript": "Waten iqungqertuq: maani nunami pekqurallerpeni",
        "translation": "It has this result: as you travel on this land"
    },
    "221": {
        "startTime": 1349.8,
        "endTime": 1355.5,
        "transcript": "Caknerpak arenqiallugtaassiyaapek'nak pekqurnaurtuten nunami maani.",
        "translation": "You may travel without severe misfortune on this land."
    },
    "222": {
        "startTime": 1356.0,
        "endTime": 1361.5,
        "transcript": "Tamaa-i tamana akqutii tamatum.",
        "translation": "That's its promise."
    },
    "223": {
        "startTime": 1363.0,
        "endTime": 1367.0,
        "transcript": "Mat'um-llu maa-i nallini waten ayuqeciqut:",
        "translation": "And these days, they will be like this:"
    },
    "224": {
        "startTime": 1370.0,
        "endTime": 1376.5,
        "transcript": "Neqlilqengramteki, neqlilqengramteki clean up-aarluku",
        "translation": "Even our fish camps, clean up even our fish camps"
    },
    "225": {
        "startTime": 1377.0,
        "endTime": 1382.0,
        "transcript": "Neqalleq-llu erurluku ulligcivigni wall'u allani.",
        "translation": "And wash the fish off of fish cutting areas or other places."
    },
    "226": {
        "startTime": 1382.5,
        "endTime": 1391.0,
        "transcript": "Neqaller ulligcivimteńi neqsurvimteńi tuani tauna uqlarpek'naku cavilqunek wall' kalikallernek.",
        "translation": "Do not pollute the fish, our fish cutting areas, or fishing grounds with metals or paper products."
    },
    "227": {
        "startTime": 1392.0,
        "endTime": 1396.0,
        "transcript": "Kalikallret ekuanarqai ekuavigmek taqulluta.",
        "translation": "We must make incinerators and burn paper products."
    },
    "228": {
        "startTime": 1396.5,
        "endTime": 1402.5,
        "transcript": "Cavilput-llu teq'ernarqaput Kusquqvamteńun mermun egtevkenaki",
        "translation": "We should also bury our metal [trash] into pits, not throw them into the water of our Kuskokwim River"
    },
    "229": {
        "startTime": 1404.5,
        "endTime": 1409.5,
        "transcript": "Qallran neqairuciiqngakut tamana Kusquqvak.",
        "translation": "Because we will have no more fish on the Kuskokwim when that rusts."
    },
    "230": {
        "startTime": 1411.8,
        "endTime": 1417.0,
        "transcript": "Tamaa-i tamana arcaqerluku wangkuta murilkarkaqerput.",
        "translation": "That is the most important thing we must watch over."
    },
    "231": {
        "startTime": 1418.0,
        "endTime": 1422.0,
        "transcript": "Ukvelrianek aterpagingaukut mat'um nalliini.",
        "translation": "We are called [Christian] believers these days."
    },
    "232": {
        "startTime": 1423.0,
        "endTime": 1430.0,
        "transcript": "Ukvelriarukumta pikenrilkevut nuna clean up-aarrlainarluku piyartukut.",
        "translation": "If we are believers, we would always clean up land that is not ours."
    },
    "233": {
        "startTime": 1430.5,
        "endTime": 1436.0,
        "transcript": "Agayutmun wangkutnun navriutekaa assirluku atuusqelluku wangkutnun.",
        "translation": "We should properly use what God has lent to us."
    },
    "234": {
        "startTime": 1436.5,
        "endTime": 1441.5,
        "transcript": "Tau͡gaam wangkuta taringumanrilamta mat'um nalliini.",
        "translation": "But we do not understand this days."
    },
    "235": {
        "startTime": 1442.0,
        "endTime": 1445.0,
        "transcript": "Qitevtellrata-wa pillikai ayagyuat.",
        "translation": "It's probably because the young people speak English."
    },
    "236": {
        "startTime": 1445.5,
        "endTime": 1450.0,
        "transcript": "Tamatum cairtutellriatun ayuqaakut.",
        "translation": "It's like that depriving us of everything."
    },
    "237": {
        "startTime": 1451.0,
        "endTime": 1457.0,
        "transcript": "Pissuryaraput-llu neqairusngiinalriatun ayuqevkarluki uqlarluni.",
        "translation": "And the pollution is depriving food of our hunting and gathering grounds."
    },
    "238": {
        "startTime": 1457.5,
        "endTime": 1465.0,
        "transcript": "Tamana qitevcaram anirturngaitaakut mat'um tau͡gaam ukvertallemta",
        "translation": "That ability to speak English will not save us, only our belief"
    },
    "239": {
        "startTime": 1465.5,
        "endTime": 1470.0,
        "transcript": "Ukverkun-llu carririllemta qigcikluku nunavut.",
        "translation": "And cleaning up our land out of respect through faith."
    },
    "240": {
        "startTime": 1470.5,
        "endTime": 1477.8,
        "transcript": "Au͡gkut tang ciuliamta waten ayuqekiit man'a nunaseng atuqseng:",
        "translation": "You see, this is how our ancestors back then treated this land that they used:"
    },
    "241": {
        "startTime": 1478.5,
        "endTime": 1482.0,
        "transcript": "Yuilqurrungraan enemegcetun qigcikluku.",
        "translation": "They would respect even the wilderness as their own houses."
    },
    "242": {
        "startTime": 1482.5,
        "endTime": 1493.0,
        "transcript": "Tuamta-llu merteng Kusquqvak pissuryarateng-llu, taluyaryarateng-llu can'giircuryarateng qigcikluki.",
        "translation": "And then, they also respecting the Kuskokwim, their water where they subsist, and the places where they trap blackfish."
    },
    "243": {
        "startTime": 1494.8,
        "endTime": 1503.5,
        "transcript": "Watqapik-llu cikutesqevkenaki aruisqevkenaki-llu neqnek taluyat neqairuciiqniluki.",
        "translation": "And they would never let them freeze or spoil [what they had caught] saying that the fish traps would not get fish anymore."
    },
    "244": {
        "startTime": 1504.5,
        "endTime": 1514.0,
        "transcript": "Tuatnalriit amllerrata watua maa-i, kuvyanek-llu aruilrianek neqairusngiinartuq.",
        "translation": "Because there is a lot of that now, and drift nets spoiling [catch], the fish are depleting."
    },
    "245": {
        "startTime": 1514.5,
        "endTime": 1520.5,
        "transcript": "Tamaaggun taringnarqaakut wangkuta Agayutmek aniqlaamacirput.",
        "translation": "We must understand that God has cursed us through that."
    },
    "246": {
        "startTime": 1520.6,
        "endTime": 1530.0,
        "transcript": "Camek enuryugcingiinarluta, neqkanek-llu enuryugciriinarluta neqnek wangkuta pisqutacimcetun.",
        "translation": "We have worsening shortages of things, shortages of fish, the food that we are given."
    },
    "247": {
        "startTime": 1530.4,
        "endTime": 1537.0,
        "transcript": "Angu ataki tang umyuallgutekluta tamamta ciulirnerni",
        "translation": "My goodness, let all of us elders be in accordance"
    },
    "248": {
        "startTime": 1537.8,
        "endTime": 1544.5,
        "transcript": "Kinguput makut ayuqucirturnauput mat'um nunam auluklerkaanek menuunaku.",
        "translation": "Let us instruct our descendants to take care of this land to keep it pristine."
    },
    "249": {
        "startTime": 1544.6,
        "endTime": 1552.5,
        "transcript": "Ataam menuiruskan Agayutem atawaqerceciiqaa quyakuni pinrilngaunaku-llu.",
        "translation": "When it is pristine again, God will certainly bless it our of gratitude."
    },
    "250": {
        "startTime": 1553.5,
        "endTime": 1565.0,
        "transcript": "Atawaqerceskani cat amlleriarkaugut wangkuta nertukput, tuniat, unangengnaquteput-llu cali ayuqluki tuaten.",
        "translation": "When he blesses it, the things we eat, sell, and gather will increase all in the same way."
    },
    "251": {
        "startTime": 1566.7,
        "endTime": 1575.5,
        "transcript": "Tayima radio-tgun niicugniaqama-llu wiinga iliini qallatellrianek quyalartua.",
        "translation": "I am thankful when I hear people sometimes talking [about traditional wisdom] on the radio."
    },
    "252": {
        "startTime": 1575.6,
        "endTime": 1580.0,
        "transcript": "Mat'umek arcaqalriamek up'nerkaq umyuangellemnek",
        "translation": "This important thought that I had last spring"
    },
    "253": {
        "startTime": 1581.0,
        "endTime": 1588.0,
        "transcript": "Iigemkun tangaallemnek qanerkanglua utertellemnek qalarutamci niicugnilriani tamarpeci.",
        "translation": "I am speaking to all of you who are listening about what I wanted to say about the things I saw with my own eyes."
    },
    "254": {
        "startTime": 1590.0,
        "endTime": 1594.9,
        "transcript": "Ayagyuaput yagutnariaput tuaten ayuqesqelluki.",
        "translation": "We must raise up our young people to be like that."
    },
    "255": {
        "startTime": 1595.0,
        "endTime": 1605.5,
        "transcript": "Waniwa wiinga yuunka tuaten akaarnek ayagluki ayuqucaaqanka clean up-aatuluki pisqelluki.",
        "translation": "Now, I have been like that with my children for a long time, telling them to clean up regularly."
    },
    "256": {
        "startTime": 1605.6,
        "endTime": 1613.5,
        "transcript": "Takuatni-llu tangvagtellua carriritulua, neqlilput-llu carrituluku tangvagtellua.",
        "translation": "And I have them watch me as I clean up in front of them, and have them watch me clean up our fish camp."
    },
    "257": {
        "startTime": 1614.0,
        "endTime": 1618.5,
        "transcript": "Makut-llu uqulkuutellret can-allret mermun egtesqevkenaki.",
        "translation": "I also tell them not to throw these empty motor oil cans into the water."
    },
    "258": {
        "startTime": 1619.0,
        "endTime": 1628.0,
        "transcript": "Wii plastic-aamun caquluki nunamun elallemnun egtelaranka.",
        "translation": "I wrap them in plastic and throw them into holes that I dug in the ground."
    },
    "259": {
        "startTime": 1628.5,
        "endTime": 1637.5,
        "transcript": "Qanqainarpek'nii tangvagtellua ukunun wii yumnun tuaten ayuqucirturluki wii calillemnun.",
        "translation": "I don't only tell them, but instruct my children on what I do by having them watch me."
    },
    "260": {
        "startTime": 1638.8,
        "endTime": 1642.5,
        "transcript": "Tuaten piyunarqukut ataulriani aanaulriani-llu",
        "translation": "We fathers and mothers must do that"
    },
    "261": {
        "startTime": 1643.0,
        "endTime": 1647.9,
        "transcript": "Ayagmek man'a ciuliamcetun nunavut qigciklerkaa",
        "translation": "To respect our land like our ancestors since the beginning"
    },
    "262": {
        "startTime": 1648.0,
        "endTime": 1652.5,
        "transcript": "Murilkelluku-llu assirluku-llu menuunaku-llu atullerkaa.",
        "translation": "And to watch over, use it well, and keep it pristine."
    },
    "263": {
        "startTime": 1653.5,
        "endTime": 1658.0,
        "transcript": "Piluaqerciqvagceta tuaten pikumta.",
        "translation": "My, we will do well if we do that."
    },
    "264": {
        "startTime": 1659.8,
        "endTime": 1665.0,
        "transcript": "Amani-qaa ernermi nangneqlirmi quyavikngaitaakut Agayutem?",
        "translation": "Will God not thank us in the last day?"
    },
    "265": {
        "startTime": 1665.1,
        "endTime": 1670.0,
        "transcript": "Nunani clean up-aalallruniluku-qaa qanrusngaitaakut?",
        "translation": "Will he not tell us that we cleaned up his land?"
    },
    "266": {
        "startTime": 1671.0,
        "endTime": 1682.5,
        "transcript": "Elliin pikngamiu nallunailngurmek clean up-aaturillret avani ciuqvani nukalpiarurcet'larai.",
        "translation": "Because he owns it, he certainly made those who cleaned up into great hunters a long time ago."
    },
    "267": {
        "startTime": 1683.0,
        "endTime": 1685.9,
        "transcript": "Tamana ayagneqluku.",
        "translation": "Begin with that."
    },
    "268": {
        "startTime": 1686.0,
        "endTime": 1688.9,
        "transcript": "Man'a amlleqapigtuq.",
        "translation": "There is a lot to this."
    },
    "269": {
        "startTime": 1689.5,
        "endTime": 1694.0,
        "transcript": "Qanruteksuumirluku qanrutkaqa tekicama.",
        "translation": "I've said what I wanted to say when I arrived."
    },
    "270": {
        "startTime": 1694.1,
        "endTime": 1703.0,
        "transcript": "Agayuvigni-llu qalarutkela'arqa man'a clean up-aarluteng nunam atullerkaa mer'em-llu tamarkenka.",
        "translation": "I also talk about how to clean up both the land and water in churches."
    },
    "271": {
        "startTime": 1703.5,
        "endTime": 1705.0,
        "transcript": "Qigcikluki.",
        "translation": "Respect them."
    },
    "272": {
        "startTime": 1705.5,
        "endTime": 1707.5,
        "transcript": "Amlleqapiartuq man'a.",
        "translation": "There is so much to this."
    },
    "273": {
        "startTime": 1708.0,
        "endTime": 1721.8,
        "transcript": "Pinritevkenaku ayagyuaput ayuqluta mat'umek yagulluki qalarutnariaput menuunaku man'a pisqelluku.",
        "translation": "Let us all not fail to raise up our young people and tell them to keep this [earth] pristine."
    },
    "274": {
        "startTime": 1722.0,
        "endTime": 1724.4,
        "transcript": "Waten ukut yuunka pilaranka:",
        "translation": "I say this to my children:"
    },
    "275": {
        "startTime": 1724.5,
        "endTime": 1730.5,
        "transcript": "Unugpak-llu qavalqeng'erpeciu clean up-aarrlainarluku unitelarciu.",
        "translation": "Even if you had slept there for the night, always leave it cleaned up."
    },
    "276": {
        "startTime": 1731.0,
        "endTime": 1733.0,
        "transcript": "Tuaten qanrucunarqaput.",
        "translation": "We must tell them that."
    },
    "277": {
        "startTime": 1733.7,
        "endTime": 1737.9,
        "transcript": "Maa-i tangaalartua terr'ilitallernek-llu",
        "translation": "These days, I also see used diapers"
    },
    "278": {
        "startTime": 1738.0,
        "endTime": 1743.0,
        "transcript": "Kenkek'ngaita terr'ilitallrit tegingaluteng, paivngaluteng.",
        "translation": "The used diapers of their loved ones are [scattered], a lot."
    },
    "279": {
        "startTime": 1743.5,
        "endTime": 1749.0,
        "transcript": "Agayutem-kiq tangvallrani quyanarqenripagtat tamakut?",
        "translation": "Are those not a cause for ingratitude in God's eyes?"
    },
    "280": {
        "startTime": 1750.4,
        "endTime": 1757.7,
        "transcript": "Umyuallgutekluta ciuliamcetun man'a nunavut auluknariarput clean up-aarumarrlainarluku.",
        "translation": "It's time for us to take care of our land in accordance like our ancestors, keep it cleaned up."
    },
    "281": {
        "startTime": 1758.0,
        "endTime": 1762.0,
        "transcript": "Quyana. Niicugnikuvci quyavikamci-llu.",
        "translation": "Thank you. I thank you if you're listening."
    },
    "282": {
        "startTime": 1762.5,
        "endTime": 1771.5,
        "transcript": "Wiinga-llu tuaten qanrutlemtun tuaten pingnaqu'urciqua piyunarquciqa maliggluku.",
        "translation": "I will also try to do that as I've said as much as I can."
    },
    "283": {
        "startTime": 1772.0,
        "endTime": 1777.0,
        "transcript": "Tua-i quyana mat'umek arcaqakekemnek qanrulluci.",
        "translation": "Thank you, I have told you what I think is important."
    },
    "284": {
        "startTime": 1778.0,
        "endTime": 1784.0,
        "transcript": "Yuunertuyaraullinian-llu tamana ak'anun clean up-aariyaraq.",
        "translation": "Cleaning up apparently also makes for a long life."
    },
    "285": {
        "startTime": 1785.0,
        "endTime": 1788.0,
        "transcript": "Au͡gna, au͡gna ava-i wani taq'uq.",
        "translation": "That [subject] is over now."
    },
    "286": {
        "startTime": 1788.1,
        "endTime": 1796.0,
        "transcript": "Kitak' allamun wani cali ek'arrlunuk piyugngakuvet, allamun ek'arrluten.",
        "translation": "Let's2 move to another [topic] if you can move to another."
    },
    "287": {
        "startTime": 1805.6,
        "endTime": 1806.5,
        "transcript": "Wiinga-qaa ukatmurrlua?",
        "translation": "Should I go this way?"
    },
    "288": {
        "startTime": 1810.4,
        "endTime": 1814.0,
        "transcript": "Kitak' waniw' aptenqigteqataramken allamek.",
        "translation": "Now, I'm going to ask you something else."
    },
    "289": {
        "startTime": 1814.5,
        "endTime": 1817.0,
        "transcript": "Waten-gguq elliussiyaagtuten.",
        "translation": "[S]he said you're doing this too much."
    },
    "290": {
        "startTime": 1818.0,
        "endTime": 1821.5,
        "transcript": "Pektaassiyaagpek'nak uitangnaqu'urluten piniartuten.",
        "translation": "Please try to stay still without moving too much."
    },
    "291": {
        "startTime": 1822.0,
        "endTime": 1825.4,
        "transcript": "Ava-i wani qangvaq cali panivet iliit",
        "translation": "Sometime recently, one of your daughters"
    },
    "292": {
        "startTime": 1825.5,
        "endTime": 1835.0,
        "transcript": "Panivet iliit apqangssallemteńi waten au͡g'um aptellrua qaillun anglicaumallranek.",
        "translation": "When we interviewed one of your daughters, [s]he asked her now she was raised."
    },
    "293": {
        "startTime": 1835.5,
        "endTime": 1839.0,
        "transcript": "Tua-i-ll' piluni ellii umyuarteqniluni waten:",
        "translation": "And then she said that this is what she thought:"
    },
    "294": {
        "startTime": 1839.8,
        "endTime": 1850.0,
        "transcript": "Waten tua-i ilaseng picurlagaqan aipaallerpet im'um quyurrluki tamalkuita inerqulallri.",
        "translation": "When one of their peers misbehaved, your late wife would gather them all and admonish them."
    },
    "295": {
        "startTime": 1851.0,
        "endTime": 1857.0,
        "transcript": "Qaillun tuaten-qaa piluni inerquilleq maa-i",
        "translation": "How is admonishing like that now"
    },
    "296": {
        "startTime": 1857.5,
        "endTime": 1862.0,
        "transcript": "Maa-i iciw' niiqurangelriakut kina una ilallugun ik'iku'urluku kiingan tua-i.",
        "translation": "You know, we've started hear know that people only discriminate against someone who misbehaves."
    },
    "297": {
        "startTime": 1863.0,
        "endTime": 1867.5,
        "transcript": "Kenkessiyaagpek'naku-llu iliini ilakellriit ukut piaqluku",
        "translation": "And some who are families do not love him too much"
    },
    "298": {
        "startTime": 1867.8,
        "endTime": 1874.0,
        "transcript": "Ikiungan, niicuilan, taangatuan, catuan, tua-i allakaucugturluku.",
        "translation": "Separating him because he's mischievous, disobedient, an alcoholic, or something else."
    },
    "299": {
        "startTime": 1874.2,
        "endTime": 1885.0,
        "transcript": "Qaillun elpetek imna-llu aipallren-llu irniatek anglicallruceteki?",
        "translation": "How did you and your late wife raise your children?"
    },
    "300": {
        "startTime": 1886.0,
        "endTime": 1889.0,
        "transcript": "Irniamek qaill' anglicarilleq ayuqa?",
        "translation": "What is raising a child like?"
    },
    "301": {
        "startTime": 1891.0,
        "endTime": 1897.5,
        "transcript": "Avaken ciuliamteńek cali qanruyutnguuq avaken anglicaraq.",
        "translation": "Child rearing is also part of the traditional wisdom from our ancestors back then."
    },
    "302": {
        "startTime": 1899.7,
        "endTime": 1911.0,
        "transcript": "Avani atama wiinga anglicallruanga, pinarqaqama-wa pilallikiinga tayima mulngakevkenii ayuqucirturaqlua.",
        "translation": "My father raised me back then, and probably when I needed it, he would instruct me without regard [for my feelings]."
    },
    "303": {
        "startTime": 1911.5,
        "endTime": 1919.5,
        "transcript": "Wall'u cali ukut ilanka alqanka-llu quyurrluki ayuqucirturaqlutayullerkamteńek.",
        "translation": "Or, he would also gather my family and my older sisters to instruct us on how we should live."
    },
    "304": {
        "startTime": 1919.8,
        "endTime": 1922.0,
        "transcript": "Tuamta-llu waten piaqluta:",
        "translation": "And then they would say this to us:"
    },
    "305": {
        "startTime": 1923.4,
        "endTime": 1931.0,
        "transcript": "“Ilavceńi quyinruluci yuuyaqunaci. Kingunerraatgun tau͡gaam yuukici.”",
        "translation": "“Do not despise your peers in life. Instead, humble yourselves before them in life.”"
    },
    "306": {
        "startTime": 1931.5,
        "endTime": 1944.0,
        "transcript": "Au͡gna qanruyun nutem aturluku yuukilta-gguq ilamta canek tutmaqiicetun umyuarput tuaten angtaluku.",
        "translation": "Adhering to that ancient piece of wisdom, our pride should be as much as what they tread upon in our live."
    },
    "307": {
        "startTime": 1944.1,
        "endTime": 1949.0,
        "transcript": "Canegtun tutmaqiicetun umyuarput quyigivkenaku.",
        "translation": "Let us be as humble as the grass they tread upon."
    },
    "308": {
        "startTime": 1950.0,
        "endTime": 1959.0,
        "transcript": "Tua-i-llu wiinga au͡gkut waten nuliangama aplua irnianglua-llu",
        "translation": "And then they asked me when I took a wife and had children"
    },
    "309": {
        "startTime": 1959.5,
        "endTime": 1966.0,
        "transcript": "Irniangama atama qanrutaanga, “Tua-i-w' elpet ataurtellriaten.",
        "translation": "When I had children my father said to me, “You are now a father."
    },
    "310": {
        "startTime": 1966.5,
        "endTime": 1971.5,
        "transcript": "“Ayuqucirteńgurrluten uumun yugpenun yuurtellriamun.",
        "translation": "“You are now an instructor for your child who is born."
    },
    "311": {
        "startTime": 1973.0,
        "endTime": 1976.7,
        "transcript": "“Wii qanrusngaitamken ayuqucirturngaunak-llu.",
        "translation": "“I will not teach or instruct you."
    },
    "312": {
        "startTime": 1977.0,
        "endTime": 1986.0,
        "transcript": "“Ak'a ayuqucirtullruamkun uumun irniavnun kenkek'ngarpenun egmirtarkarpenek.",
        "translation": "“I have already instructed you on what you should pass on to your child whom you love."
    },
    "313": {
        "startTime": 1986.7,
        "endTime": 1991.5,
        "transcript": "“Wiinga-llu qalarut'lallruamken wii pikenrilkemnek.",
        "translation": "“I have also talked to you about what has not originated from me."
    },
    "314": {
        "startTime": 1991.6,
        "endTime": 1996.0,
        "transcript": "“Atama qanruyutai elpenun egmirtellruanka.",
        "translation": "“I've passed on my father's traditional wisdom onto you."
    },
    "315": {
        "startTime": 1996.5,
        "endTime": 2004.5,
        "transcript": "“Elpet tuatnaurtuten, tau͡gaam murilkeciqamken. Qanrutnarqekuvet qanruciiqamken.”",
        "translation": "“You are doing that, but I will watch you. I will admonish you when you warrant it.”"
    },
    "316": {
        "startTime": 2005.5,
        "endTime": 2011.5,
        "transcript": "Tua-i-llu waten: “Irniat ayuqsuitut.”",
        "translation": "And then this: “Children are different.”"
    },
    "317": {
        "startTime": 2013.0,
        "endTime": 2020.0,
        "transcript": "Waniwa nine-aanek yungqertua wii.",
        "translation": "Now I have nine children."
    },
    "318": {
        "startTime": 2021.5,
        "endTime": 2028.0,
        "transcript": "Five-aat angutnguluteng, pingayun arnauluteng.",
        "translation": "Five are male, and three are female."
    },
    "319": {
        "startTime": 2030.8,
        "endTime": 2038.4,
        "transcript": "Ukut yuut ayuqsuitut. Una qanrucunaunani-am iliit piyugtuq, narugciyugluni.",
        "translation": "These people are different. One of them tends to be mischievous and disregards [instruction or wisdom]."
    },
    "320": {
        "startTime": 2038.5,
        "endTime": 2043.0,
        "transcript": "Ayuqsuitelliniut au͡gkut ciuliat qanruyuciicetun.",
        "translation": "They're evidently different as our ancestors back then have said."
    },
    "321": {
        "startTime": 2043.8,
        "endTime": 2049.0,
        "transcript": "Aqsamek-gguq ataucimek anellrung'e'rmeng kinguvret ayuqsuitut.",
        "translation": "They say that descendants are different even when they shared a womb."
    },
    "322": {
        "startTime": 2049.5,
        "endTime": 2051.0,
        "transcript": "Tuaten qanlartut.",
        "translation": "That's what they say."
    },
    "323": {
        "startTime": 2051.4,
        "endTime": 2059.5,
        "transcript": "Tau͡gaam ayuqsuilengraata una tang arcaqerluku naklekun qanruyutngulria.",
        "translation": "But even though they are different, compassion is the most important piece of traditional wisdom."
    },
    "324": {
        "startTime": 2060.5,
        "endTime": 2062.5,
        "transcript": "Waten-llu qanrut'lallruitkut:",
        "translation": "They also used to tell us this:"
    },
    "325": {
        "startTime": 2063.5,
        "endTime": 2070.5,
        "transcript": "“Una wani ilasi inerciigalnguukan, qanrutesciigalnguukan",
        "translation": "“If one of your family members is mischievous and disobedient"
    },
    "326": {
        "startTime": 2070.6,
        "endTime": 2077.5,
        "transcript": "“Elpeci tua-i anelgutaini tuaten pinritengnaqu'urluci yuungavci",
        "translation": "“Because youpl, his siblings, try not to be like that in life"
    },
    "327": {
        "startTime": 2078.0,
        "endTime": 2085.4,
        "transcript": "“Una tang anelgutsi qanrutnarkaqerci elpeci quyurrluci anelgutaini.",
        "translation": "“Youpl, his siblings, must gather and admonish him."
    },
    "328": {
        "startTime": 2085.5,
        "endTime": 2093.5,
        "transcript": "“Nunurpek'naku, ik'ikevkenaku, tau͡gaam kenekluku elluarrluku piluku.",
        "translation": "“Do not scold or criticize him, but treat him well with love."
    },
    "329": {
        "startTime": 2093.6,
        "endTime": 2099.0,
        "transcript": "“Qallatellerci-llu tegg'ivkenaku, unganarqellriaruluku tau͡gaam.",
        "translation": "“And do not speak harshly, but with tenderhearted love."
    },
    "330": {
        "startTime": 2100.0,
        "endTime": 2106.0,
        "transcript": "“Ilasi una anelgutsi tuaten ayuqngan qalarutarkaugarci kenekluku.”",
        "translation": "“Because yourpl sibling is like that, youpl must admonish him with love.”"
    },
    "331": {
        "startTime": 2107.0,
        "endTime": 2118.0,
        "transcript": "Tuamta-llu nengaungekuvet, avaken ayagluni piciryarauguq",
        "translation": "And then if you take in a son-in-law, it's an ancient custom"
    },
    "332": {
        "startTime": 2118.8,
        "endTime": 2130.5,
        "transcript": "Nengaungekuvet nengaugen una ukuni irniarpeni nakmiin kenkenruluki kenkekiu.",
        "translation": "If you take in a son-in-law, love him more than your own children."
    },
    "333": {
        "startTime": 2131.5,
        "endTime": 2142.0,
        "transcript": "Qaillun pingraan pillagavkenaku, unganaqluten tau͡gaam qanrutaqluku, unganaqluten tau͡gaam ayuqucirturluku.",
        "translation": "No matter what he does, do not react violently to him, but speak to him and instruct him with tenderhearted love."
    },
    "334": {
        "startTime": 2143.0,
        "endTime": 2151.0,
        "transcript": "Tuaten wiinga nengauka tuatnayugyaaquq, taangamek-llu mat'umek atutuyaaqluni",
        "translation": "My son-in-law is [mischievous] like that, and he abuses this alcohol"
    },
    "335": {
        "startTime": 2151.5,
        "endTime": 2160.0,
        "transcript": "Tau͡gaam ayuqucirtuuteka maliggluku qancurlagateksaitaqa man'a erneq engelkarrluku.",
        "translation": "But I have never spoken harshly to him to this day according to what I was instructed."
    },
    "336": {
        "startTime": 2160.1,
        "endTime": 2172.0,
        "transcript": "Ayuqucirtuqallma carrarmek avatiini unganaqluku tuavet qanruyun qanruyutekluku nakmiin nengaumnun.",
        "translation": "Concerning what little instruction I gave [him], I talked about that wisdom with tenderhearted love for my own son-in-law."
    },
    "337": {
        "startTime": 2172.5,
        "endTime": 2179.0,
        "transcript": "Taumek mat'um nalliini nengauma taum unisngasciigataanga.",
        "translation": "That's why my son-in-law cannot leave me alone today."
    },
    "338": {
        "startTime": 2179.4,
        "endTime": 2184.0,
        "transcript": "Camek-llu pikuma tangerqunia ikayurarkaulua.",
        "translation": "And if he seens that I need something, he will help me."
    },
    "339": {
        "startTime": 2184.5,
        "endTime": 2189.5,
        "transcript": "Man'a kenkem atungnaqurallrua tuaten ayuquq.",
        "translation": "That's what trying to treat everyone with love is like."
    },
    "340": {
        "startTime": 2190.5,
        "endTime": 2193.8,
        "transcript": "Tuaten ayuqerkaulliniukut.",
        "translation": "We must be like that."
    },
    "341": {
        "startTime": 2194.0,
        "endTime": 2200.0,
        "transcript": "Tuamta-llu ava-i qanrutekngataqa ciuqlirmek",
        "translation": "And then, I think I just talked about it first"
    },
    "342": {
        "startTime": 2200.5,
        "endTime": 2206.5,
        "transcript": "Inerciigalngurnun ik'ikekiitnun ilagautesqevkenii.",
        "translation": "That I should not join others in criticizing mischievous people."
    },
    "343": {
        "startTime": 2207.0,
        "endTime": 2213.0,
        "transcript": "Tamakut tuaten ciuliamteńek ayagluni qanruyutnguuq tamana.",
        "translation": "That is traditional wisdom from our ancestors."
    },
    "344": {
        "startTime": 2213.8,
        "endTime": 2219.2,
        "transcript": "Tamaa-i-gguq yuum ukvelriim…",
        "translation": "They say that a [Christian] believer…"
    },
    "345": {
        "startTime": 2219.3,
        "endTime": 2227.0,
        "transcript": "Au͡gkut ukvelrianek qanyuicaaqut tau͡gaam waten qanrucunalrianek.",
        "translation": "Back then, they didn't talk about believers, but obedient people."
    },
    "346": {
        "startTime": 2228.0,
        "endTime": 2232.5,
        "transcript": "Qanrucunalrianek tau͡gaam ukvelriit acilallrulliniit.",
        "translation": "Instead, they called believers obedient."
    },
    "347": {
        "startTime": 2232.6,
        "endTime": 2236.0,
        "transcript": "Mat'um nalliini ukvelrianek acingait.",
        "translation": "These days, they call them [Christian] believers."
    },
    "348": {
        "startTime": 2237.0,
        "endTime": 2241.9,
        "transcript": "Avani tau͡gken ciuliamteńi qanrucunalrianek piaqluki",
        "translation": "Back then, however, our ancestors called them qanrucunalriit"
    },
    "349": {
        "startTime": 2242.0,
        "endTime": 2254.5,
        "transcript": "Imna umuyuarteng aturpek'naku ayuqucirtuutminek tau͡gaam atungnaqurilria tauna qanrucunalriamek aterpagtelallrulliniat.",
        "translation": "They referred to someone who did not do whatever he wanted but adhered to his instructions as obedient."
    },
    "350": {
        "startTime": 2255.8,
        "endTime": 2263.0,
        "transcript": "Wangkuta tau͡gken mat'um nalliini ukverumalrianek aterpagingaukut, aterpagtaqluku tauna qanrucunalria.",
        "translation": "These days, however, we are called believers, call that obedient person [a believer]."
    },
    "351": {
        "startTime": 2264.7,
        "endTime": 2277.5,
        "transcript": "Tuaten ayuqesqumaakut akaarnun, akaarnun nangengqallerkarput, cali ak'anun pinimek cikiumaqallerkarput pitekluku.",
        "translation": "They told us to be like that so that we would stand [alive] for a long time and that we would be given long-lasting strength."
    },
    "352": {
        "startTime": 2278.0,
        "endTime": 2283.0,
        "transcript": "Makut ayuqucirtuutngulliniut waten qanerluteng,",
        "translation": "These are evidently instructions saying this,"
    },
    "353": {
        "startTime": 2285.0,
        "endTime": 2288.0,
        "transcript": "Qalaruqaarluta qanlartut waten:",
        "translation": "After they instructed us, they would say this:"
    },
    "354": {
        "startTime": 2288.1,
        "endTime": 2295.0,
        "transcript": "“Yuum-gguq tau͡gaam kenkek'ni ayuqucirtutua elluarrluku agglerkaanek.”",
        "translation": "“A person instruction whom he loves so that [s]he will live well.”"
    },
    "355": {
        "startTime": 2297.0,
        "endTime": 2312.5,
        "transcript": "Tamakut-am Jesus-aam qaneryaramikun nalqikanirai waten elitnauraminun qanerluni John 6 verse 63-aami.",
        "translation": "Jesus further explained those with his words saying this to his disciples in John 6 verse 63."
    },
    "356": {
        "startTime": 2312.8,
        "endTime": 2318.0,
        "transcript": "John 6 verse 63, Jesus-aaq qanertuq tungaunani,",
        "translation": "John 6 verse 63, Jesus explicitly said,"
    },
    "357": {
        "startTime": 2319.0,
        "endTime": 2327.0,
        "transcript": "“Elpeceńun qaneryaraqellrenka anerneruut unguvauluteng-llu.”",
        "translation": "“My words to you are breath and life.”"
    },
    "358": {
        "startTime": 2328.0,
        "endTime": 2334.0,
        "transcript": "Avani ciuliamteńi Bible-aartangvailgan qanruyun waniwa:",
        "translation": "Here is wisdom from back before our ancestors before there was a Bible:"
    },
    "359": {
        "startTime": 2334.8,
        "endTime": 2346.0,
        "transcript": "Elpet nukalpiami alqunaq picurlagmun tekiararesquvet anayunailngalngurmun",
        "translation": "If you, a great hunter, come upon misfortune that you cannot survive"
    },
    "360": {
        "startTime": 2346.5,
        "endTime": 2354.8,
        "transcript": "Umyugairuskuvet qanruyuteten-llu umyuaqenrilkuvki",
        "translation": "If you flustered and do not remember the traditional wisdom you heard"
    },
    "361": {
        "startTime": 2354.9,
        "endTime": 2360.5,
        "transcript": "Eneqallanrilkuvki elpenek picitun, elpenek tuquciiquten.",
        "translation": "If you do not remember them, you will die by your own fault."
    },
    "362": {
        "startTime": 2361.5,
        "endTime": 2369.5,
        "transcript": "Tau͡gken picurlagmun tekiarteng'e'rpet imkut qanruyutet eneqaquvki",
        "translation": "Yet even if you come upon misfortune, if you remember traditional wisdom"
    },
    "363": {
        "startTime": 2370.8,
        "endTime": 2378.0,
        "transcript": "Eneqallerpet tamakut qanruyutvet pinimek cikirciqaaten tuaken-llu anagcetarkauluten.",
        "translation": "The wisdom you remember will give you strength and save you from that."
    },
    "364": {
        "startTime": 2378.5,
        "endTime": 2385.5,
        "transcript": "Tamaa-i-ngulliniuq anerneruciat unguvauciat-llu makut ayuqucirtuutet.",
        "translation": "That is apparently how these instructions are breath and life."
    },
    "365": {
        "startTime": 2385.8,
        "endTime": 2389.5,
        "transcript": "Wangkutnun atunricunaicaaqelliniluteng.",
        "translation": "We must adhere to them."
    },
    "366": {
        "startTime": 2391.5,
        "endTime": 2394.0,
        "transcript": "Waten-llu cali pinauraitkut:",
        "translation": "They would also tell us this:"
    },
    "367": {
        "startTime": 2394.9,
        "endTime": 2400.0,
        "transcript": "“Neplirpiiqnaci. Usviircararanrici.”",
        "translation": "“Quit being so noisy. Do not act so mindlessly.”"
    },
    "368": {
        "startTime": 2400.1,
        "endTime": 2404.0,
        "transcript": "Tuaten-llu qanraqluteng nepliqeryaaqaqamta enemteńi.",
        "translation": "They would also tell us that when we made too much noise in our homes."
    },
    "369": {
        "startTime": 2405.9,
        "endTime": 2411.5,
        "transcript": "Cavagta mat'um nalliini ayagyuaqegtaaraat",
        "translation": "Behold the precious young people these days"
    },
    "370": {
        "startTime": 2412.0,
        "endTime": 2420.0,
        "transcript": "Tengssulvak-llu imirluku ayautnaurait nunanun allanun aarpagayarturtelluki.",
        "translation": "They even fill a huge plane and bring them to other villages to make a lot of noise."
    },
    "371": {
        "startTime": 2420.5,
        "endTime": 2423.0,
        "transcript": "Waniwa-gguq angqeryarturtelluki.",
        "translation": "They say they're bringing them to play basketball."
    },
    "372": {
        "startTime": 2424.5,
        "endTime": 2427.5,
        "transcript": "Tau͡gken ciuliamteńi alerquutarluni waten:",
        "translation": "Yet there was this instruction among our ancestors:"
    },
    "373": {
        "startTime": 2428.4,
        "endTime": 2439.0,
        "transcript": "Una tan'gaurluq ellangyualria nunanun allanun ayagat'lallrukuvgu inerciigalnguuciquq.",
        "translation": "If you bring this growing boy do other villages, he will be mischievous."
    },
    "374": {
        "startTime": 2440.0,
        "endTime": 2445.5,
        "transcript": "Nunanun-llu tekiteksaileng'ermiki tangeqsaileng'ermiki-llu",
        "translation": "And even in other villages where he has never been or seen"
    },
    "375": {
        "startTime": 2446.0,
        "endTime": 2451.5,
        "transcript": "Tuavet tekiskuni talluryugmek imaunani nepliryugngaciquq tuani.",
        "translation": "He will be able to be noisy there without shame when he arrives."
    },
    "376": {
        "startTime": 2452.0,
        "endTime": 2458.9,
        "transcript": "Tamaa-i-gguq ayagacimalriim nunakenrilkeminun ellangyuallrani ayuqucia ukanirpak.",
        "translation": "They say that's what one who was brought to outside villages when he was growing up has always been like."
    },
    "377": {
        "startTime": 2459.5,
        "endTime": 2463.0,
        "transcript": "Ak'a ellaita ciulirneret tangvallruamegteggu tamana",
        "translation": "Because those ancestors have seen that"
    },
    "378": {
        "startTime": 2463.5,
        "endTime": 2469.9,
        "transcript": "Ellangyuallrani mikelnguq itertaarutesqevkenaku-llu yugnun nunameggni.",
        "translation": "They tell people not to bring a growing child to others' houses in their villages."
    },
    "379": {
        "startTime": 2470.2,
        "endTime": 2474.0,
        "transcript": "Wall'u nunanun allanun ayagatesqevkenaku.",
        "translation": "Or, they tell people not to bring them to other villages."
    },
    "380": {
        "startTime": 2474.5,
        "endTime": 2478.0,
        "transcript": "Tamaa-i alerquutiit au͡gkut ciuliamta.",
        "translation": "That is the instruction of our ancestors back then."
    },
    "381": {
        "startTime": 2480.8,
        "endTime": 2487.5,
        "transcript": "Umyuangcatulimek-gguq yungqerrsukumta tamana aturciqerput.",
        "translation": "They say that if we want a mindful child, we will adhere to that."
    },
    "382": {
        "startTime": 2489.4,
        "endTime": 2496.0,
        "transcript": "Kenkekput mikelnguput itertaarutevkenaki nunanun-ll' allanun ayagatevkenaki.",
        "translation": "We would not bring our children whom we love to other's houses, and we won't bring them to other [villages]."
    },
    "383": {
        "startTime": 2498.5,
        "endTime": 2501.5,
        "transcript": "Waten-gguq qanernaurtut ilait:",
        "translation": "They say that some would say this:"
    },
    "384": {
        "startTime": 2502.0,
        "endTime": 2507.0,
        "transcript": "“Tauna ellatuuq, usvituluni-llu, qanyuluni-llu.”",
        "translation": "“That person is sensible, wise, and articulate.”"
    },
    "385": {
        "startTime": 2507.5,
        "endTime": 2513.5,
        "transcript": "Tamaa-i-gguq ayagacimanrilnguut tuaten ayuqut ellangyuallermeggni.",
        "translation": "They say that's what people who were not taken to other places when they were growing are like."
    },
    "386": {
        "startTime": 2514.4,
        "endTime": 2519.0,
        "transcript": "Ava-i makut ciuliamteńi qanruyutet piciulriit.",
        "translation": "Those are true pieces of wisdom from our ancestors."
    },
    "387": {
        "startTime": 2519.1,
        "endTime": 2527.5,
        "transcript": "Ellaita tangvallerteng tau͡gaam ayuqucirtuutek'larait tamakut au͡gkut ciuliamta, piciulriit.",
        "translation": "Our ancestors back then teach things, true things, that they have seen."
    },
    "388": {
        "startTime": 2528.0,
        "endTime": 2529.0,
        "transcript": "Tamaa-i.",
        "translation": "There you have it."
    },
    "389": {
        "startTime": 2530.0,
        "endTime": 2549.0,
        "transcript": "Tuamta-llu cali piinanemteńi-gguq enuqlitengramta yuum pianek akluanek wall'u kapkaanaq'ngaanek watqapik teguqautesqevkenata.",
        "translation": "And then they said that even if we are short on something as we live, we should never take a person's things or their traps."
    },
    "390": {
        "startTime": 2550.8,
        "endTime": 2556.0,
        "transcript": "Teglegesqevkenata, cangtairarisqevkenata-llu yuum pianek allam.",
        "translation": "They told us not to steal, or to take another person's catches."
    },
    "391": {
        "startTime": 2557.0,
        "endTime": 2559.0,
        "transcript": "Waten qanerluteng:",
        "translation": "They said this:"
    },
    "392": {
        "startTime": 2560.3,
        "endTime": 2566.0,
        "transcript": "“Tauna imarmiutaq wall'u kaviaq tegukuvgu",
        "translation": "“If you take that mink or fox"
    },
    "393": {
        "startTime": 2566.5,
        "endTime": 2575.0,
        "transcript": "“Aulukestevet Agayutem, Ellam Yuan uptellni elpenun teguvkararkauluku.",
        "translation": "“Your caretaker, God, the Spirit of the Universe, will let what was prepared to be yours be taken."
    },
    "394": {
        "startTime": 2577.0,
        "endTime": 2581.5,
        "transcript": "“Tauna tegukuvgu ataucimek teguciiquten",
        "translation": "“If you take that, you will take one"
    },
    "395": {
        "startTime": 2581.6,
        "endTime": 2593.0,
        "transcript": "“Imkut tau͡gken pikaqsalten Agayutem cimiuciiqai taum tegullerpet kapkaanaagnek pikestiignun taukuk kapkaanaak.",
        "translation": "“But God will exchange what was supposed to be yours to the one who owns the trap that you've taken."
    },
    "396": {
        "startTime": 2593.5,
        "endTime": 2597.0,
        "transcript": "“Elpet ataucimek pitangqerciquten.",
        "translation": "“You will only catch one."
    },
    "397": {
        "startTime": 2598.0,
        "endTime": 2602.0,
        "transcript": "“Pikaqsalten elpenek naivciiqaten taumun yugmun.”",
        "translation": "“You will transfer what was to be yours to that person.”"
    },
    "398": {
        "startTime": 2603.7,
        "endTime": 2606.0,
        "transcript": "Tuaten cali qanruyun tamaa-i.",
        "translation": "That's another piece of traditional wisdom."
    },
    "399": {
        "startTime": 2606.5,
        "endTime": 2609.5,
        "transcript": "Tuamta-llu cali qanernaurtut ilait",
        "translation": "And then some would also say"
    },
    "400": {
        "startTime": 2610.0,
        "endTime": 2615.7,
        "transcript": "Ilait-gguq tegucugpakarluteng iruit-llu qungagartelartut",
        "translation": "The legs of some who steal too much get crippled"
    },
    "401": {
        "startTime": 2616.0,
        "endTime": 2618.5,
        "transcript": "Wall'u talliit qungagarrluteng.",
        "translation": "Or their arms get crippled."
    },
    "402": {
        "startTime": 2618.6,
        "endTime": 2629.4,
        "transcript": "Imkut-gguq angalkuita tamakutgun caskumegteggun tuaten pivkalallruit avani ciuqvani.",
        "translation": "They say that shamans used to do that with their tools to the people who did that a long time ago."
    },
    "403": {
        "startTime": 2629.5,
        "endTime": 2636.8,
        "transcript": "Iruit qungagartelluki, talliit-llu qungagartelluki nangteqevkarluki.",
        "translation": "They crippled their legs, and crippled their arms to make them suffer."
    },
    "404": {
        "startTime": 2637.0,
        "endTime": 2643.0,
        "transcript": "Ellaita angalkut pissuutemegteggun quyanrilucimegcetun tuaten pivkarluki.",
        "translation": "Those shamans made them like that with their tools because they were unhappy with them."
    },
    "405": {
        "startTime": 2643.1,
        "endTime": 2650.0,
        "transcript": "Taumek arcaqerluku aarutkellruat yuum pianek tegutesqevkenata.",
        "translation": "That's why they especially warned us against taking a person's things."
    },
    "406": {
        "startTime": 2651.4,
        "endTime": 2654.0,
        "transcript": "Cavagtat-wa mat'um nalliini.",
        "translation": "Behold the people these days."
    },
    "407": {
        "startTime": 2654.5,
        "endTime": 2661.0,
        "transcript": "Tamana-wa ayuqucirtuutekenrilamteggu wangkuta ellangyuallratnek ayagluku",
        "translation": "Because we do not teach that starting from when they're growing"
    },
    "408": {
        "startTime": 2662.0,
        "endTime": 2668.0,
        "transcript": "Angyanek-llu ayakaucinaurtut, yuum-llu levaaranek teglegnaurtut",
        "translation": "They run off with boats, and they steal a person's boat motor"
    },
    "409": {
        "startTime": 2669.0,
        "endTime": 2674.0,
        "transcript": "Yuum-llu kuvyaanek tamalkumek angyaanek teglegnaurtut.",
        "translation": "And they would steal a person's entire drift net from his boat."
    },
    "410": {
        "startTime": 2674.9,
        "endTime": 2685.0,
        "transcript": "Man'a-wa teglegyaram tegucaram iqua alingnarqucii-llu niicuirucamegteggu tuaten ellillilriit",
        "translation": "They've probably become like that because they don't hear about the consequences of stealing and how dangerous it is"
    },
    "411": {
        "startTime": 2685.5,
        "endTime": 2691.0,
        "transcript": "Qalarucuirucamceteng tamakunek tuaten pillerkaitnek.",
        "translation": "Because we don't admonish them against doing that."
    },
    "412": {
        "startTime": 2691.5,
        "endTime": 2695.5,
        "transcript": "Amta-llu ellaita ciuliamta aarutkeqapiggluku.",
        "translation": "And yet our ancestors strongly warned against it."
    },
    "413": {
        "startTime": 2696.0,
        "endTime": 2699.0,
        "transcript": "Tau͡gaam-llu waten qanruyuterluteng:",
        "translation": "But they also had this traditional wisdom:"
    },
    "414": {
        "startTime": 2700.0,
        "endTime": 2705.0,
        "transcript": "Yuullgutput-gguq tamalkuan quyacagcuumirluku yuulta.",
        "translation": "Let us try to make every one of our fellow people happy in our lives."
    },
    "415": {
        "startTime": 2706.0,
        "endTime": 2715.0,
        "transcript": "Tangerrluku-gguq ukanirpak yuut makut cangqerrartellriit, teguqerrarrluteng-llu atu'urkameggnek.",
        "translation": "They said to look at these people who have always had things, and they gather what they need."
    },
    "416": {
        "startTime": 2715.6,
        "endTime": 2719.0,
        "transcript": "Yuut-gguq quyallratgun tuaten ayuqut.",
        "translation": "They say that they're like that through people's gratitude."
    },
    "417": {
        "startTime": 2719.5,
        "endTime": 2722.0,
        "transcript": "Quyayaraq-gguq una assirtuq.",
        "translation": "They say that gratitude is good."
    },
    "418": {
        "startTime": 2723.0,
        "endTime": 2727.0,
        "transcript": "Tua-i-ll' waten Bible-aani naaqilartua:",
        "translation": "And then I read this in the Bible:"
    },
    "419": {
        "startTime": 2731.0,
        "endTime": 2738.0,
        "transcript": "Cikiqenglleq-gguq quyanarqenruuq akurtunermi.",
        "translation": "Giving is more of a cause for gratitude than receiving."
    },
    "420": {
        "startTime": 2738.5,
        "endTime": 2743.0,
        "transcript": "Una akurtuneq cikiutminek quyanaqsaaquq",
        "translation": "It's a cause for gratitude to receive a gift"
    },
    "421": {
        "startTime": 2743.5,
        "endTime": 2748.5,
        "transcript": "Tau͡gaam una cikiqenglleq angenruniluku Bible-aat qanrutkaat",
        "translation": "But the Bible says that giving is more important"
    },
    "422": {
        "startTime": 2749.0,
        "endTime": 2756.0,
        "transcript": "Waten qanrami: “Cikiqenglleq quyanarqenruuq akurtunermi.”",
        "translation": "Because it says this: “Giving is more of a cause for gratitude than receiving.”"
    },
    "423": {
        "startTime": 2757.0,
        "endTime": 2768.5,
        "transcript": "Taumek ciuliamta una-am cali wangkuta camek avegvingqerqumta yuullgutemteńun ikayuutekesqaa kenkutnguluni.",
        "translation": "That's why our ancestors told us to help our fellow people as a form of love if we have anything to spare."
    },
    "424": {
        "startTime": 2769.0,
        "endTime": 2774.0,
        "transcript": "Tamaa-i-gguq cali yuut quyam ugaani",
        "translation": "They say that out a person's gratitude"
    },
    "425": {
        "startTime": 2775.0,
        "endTime": 2779.4,
        "transcript": "Yuum-llu temii pinimek cikilriamek ayuqelartuq.",
        "translation": "It's like a person's body is given strength."
    },
    "426": {
        "startTime": 2779.5,
        "endTime": 2782.3,
        "transcript": "Agayutem-wa tuaten pillikii.",
        "translation": "God probably does that."
    },
    "427": {
        "startTime": 2782.5,
        "endTime": 2789.0,
        "transcript": "Tuamta-llu cali kevgiurturatuluta yuusqelluta.",
        "translation": "They also told us to serve others in our lives."
    },
    "428": {
        "startTime": 2789.5,
        "endTime": 2795.5,
        "transcript": "Waten-llu qanerluteng: alumteńek-gguq ayagluta nangengaitukut.",
        "translation": "And they say this: we will not deteriorate from our soles."
    },
    "429": {
        "startTime": 2797.0,
        "endTime": 2799.0,
        "transcript": "Tuaten qantuluteng.",
        "translation": "They say that."
    },
    "430": {
        "startTime": 2799.1,
        "endTime": 2807.0,
        "transcript": "Kevgiurturallemteńi-gguq tau͡gaam piniriciqukut naullunam-llu-gguq agturngaunata.",
        "translation": "They say that as we serve, we will become stronger, and sicknesses will not touch us."
    },
    "431": {
        "startTime": 2807.5,
        "endTime": 2814.0,
        "transcript": "Naulluulrianun naulluungraata naulluutiita tamatum agturngaunata.",
        "translation": "Even if others are sick during an epidemic, they will not touch us."
    },
    "432": {
        "startTime": 2815.0,
        "endTime": 2819.0,
        "transcript": "Tamaa-i cali tamana kevgiurturyaram akqutii.",
        "translation": "That's is the promise of servitude."
    },
    "433": {
        "startTime": 2819.1,
        "endTime": 2823.0,
        "transcript": "Yuk akaarnun caciinani nangengqaarkauluni.",
        "translation": "A person will stand [alive] for a long time with any afflictions."
    },
    "434": {
        "startTime": 2824.5,
        "endTime": 2829.0,
        "transcript": "Kevgiurturyaraq-am cali una: yuut quyatuut.",
        "translation": "This also concerns servitude: people are thankful."
    },
    "435": {
        "startTime": 2829.3,
        "endTime": 2837.0,
        "transcript": "Wall'u mertaquni wall'u eqiuquni arnassagaq wall' angukara'urluq quyayugngauq tamatumek.",
        "translation": "Or, if [s]he gets water or chops wood, an old woman or old man can be thankful for that."
    },
    "436": {
        "startTime": 2837.1,
        "endTime": 2840.4,
        "transcript": "Quyatiin-gguq tauna yuk qulvaqanirciqaa.",
        "translation": "They say that his gratitude will uplift that person."
    },
    "437": {
        "startTime": 2841.0,
        "endTime": 2845.0,
        "transcript": "Tamaa-i qanruyutet tamakut ciuliamteńek.",
        "translation": "Those are our ancestors' traditional wisdom."
    },
    "438": {
        "startTime": 2846.0,
        "endTime": 2851.0,
        "transcript": "Man'a qallaquralqa amlleriyaaquq tayima.",
        "translation": "I've said a lot by now."
    },
    "439": {
        "startTime": 2851.1,
        "endTime": 2856.0,
        "transcript": "Ii-i. Ii-i, quyanarquten wani tailuten.",
        "translation": "Okay. Well, thank you for coming."
    },
    "440": {
        "startTime": 2856.1,
        "endTime": 2858.8,
        "transcript": "Waten tua-i pitari[luku].",
        "translation": "This is all for now."
    },
    "441": {
        "startTime": 2858.9,
        "endTime": 2871.0,
        "transcript": "Cam iliiniku tau͡gaam cali piyunarqeqaqumta cali quyurrluta cali qalangssagniartukut umyuangekuvet allamek cali piinanerpeni.",
        "translation": "But someday if we are able, we should gather and talk if you have something else in mind as you go along."
    },
    "442": {
        "startTime": 2871.5,
        "endTime": 2873.4,
        "transcript": "Tua-i quyana.",
        "translation": "Thank you."
    },
    "443": {
        "startTime": 2873.5,
        "endTime": 2879.0,
        "transcript": "Cali pitsaqevkenii uitacunailngurmek umyuangekuma taiciqua.",
        "translation": "I will come if by chance I think of something that must addressed."
    },
    "444": {
        "startTime": 2879.5,
        "endTime": 2887.0,
        "transcript": "Quyana tua-i. Niitellerci man'a aulukestemta atawaqercecimaniaraa.",
        "translation": "Thank you. May our caretaker bless what you have heard."
    }
};